import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, Input, KeyValueDiffers, NgZone, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { ActivatedRoute, NavigationStart, Params, Router } from '@angular/router';
import { MediaObserver, MediaChange } from '@angular/flex-layout';
import { BehaviorSubject, Observable, Subject, Subscription } from 'rxjs';
import { MeetingService } from 'src/app/service/meeting.service';
import { CodeList, MeetingCollabDetails, MeetingResponse, agendaList } from 'src/app/models/basicMeetingModel';
import { FreeFormAgendaService } from 'src/app/service/free-form-agenda.service';
import { FreeFormMinutesService } from 'src/app/service/free-form-minutes.service';
import { UtilityService } from 'src/app/service/utility.service';
import { environment, environment_const, environment_msg, environment_label } from 'src/environments/environment';
import { AttendeeService } from 'src/app/service/attendee.service';
import { Popover } from 'bootstrap';
import { UntypedFormControl } from '@angular/forms';
import { Globals } from 'src/app/service/global';
import { SideNavServiceService } from 'src/app/service/side-nav-service.service';
import { MatDialog } from '@angular/material/dialog';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConfirmDialogComponent } from 'src/app/components/confirm-dialog/confirm-dialog.component';
import { NotifierService } from 'angular-notifier';
import { NgxSpinnerService } from 'ngx-spinner';
import { ParticReviewSelectDialogComponent } from 'src/app/components/partic-review-select-dialog/partic-review-select-dialog.component';
import { PreviewMinutesDialogComponent } from 'src/app/components/preview-minutes-dialog/preview-minutes-dialog.component';
import { WebsocketService } from 'src/app/service/websocket.service';
import { WebsocketTransferService } from 'src/app/service/websocket-transfer.service';
import { TrackAttendeeDialogComponent } from '../../../components/track-attendee-dialog/track-attendee-dialog.component';
import { ShortcutDialogComponent } from 'src/app/components/shortcut-dialog/shortcut-dialog.component';
import { CancelMeetingPopupComponent } from 'src/app/components/cancel-meeting-popup/cancel-meeting-popup.component';
import { BreakpointState } from '@angular/cdk/layout';
import {
  BreakpointObserver,
  Breakpoints,
} from '@angular/cdk/layout';
import { CreateMeetingComponent } from '../../create-meeting/create-meeting.component';
import { SaveTemplateDialogComponent } from 'src/app/components/save-template-dialog/save-template-dialog.component';
import { CopymeetingComponent } from 'src/app/components/copymeeting/copymeeting.component';
import { DatePipe, formatDate } from '@angular/common';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
import { MY_FORMATS } from 'src/app/components/grid-table/grid-table.component';
import { InstantMeetingDescriptionComponent } from 'src/app/components/instant-meeting-description/instant-meeting-description.component';
import * as _moment from 'moment';
import * as _rollupMoment from 'moment';
import { MomService } from 'src/app/service/mom.service';
import { PermissionService } from 'src/app/service/permission.service';
import { UserService } from 'src/app/service/user.service';
import { ViewMomDialogComponent } from 'src/app/components/view-mom-dialog/view-mom-dialog.component';
import { first, takeUntil } from 'rxjs/operators';
import { I } from '@angular/cdk/keycodes';
import { meetingTourValues, scheduleMeetingTourValues, pastMeetingTourValues } from 'src/environments/environment';
import { DragDialogComponent } from 'src/app/components/drag-dialog/drag-dialog.component';
declare let startConversationButton: any;
declare let leaveConversationButton: any;
declare let conversationId: any;
declare let meeting_id: any;
declare let joinConversationButton: any;
declare let startSpeakingButton: any;
declare let innerHTML: any;
declare let stopSpeakingButton: any;
import moment from 'moment';
import { SendMessageDialogComponent } from 'src/app/components/send-message-dialog/send-message-dialog.component';
import { HistoryComponent } from 'src/app/components/history/history.component';
// import { MediaStreamService } from 'src/app/service/media-stream.service';
import * as RecordRTC from 'recordrtc';
import { AttachmentService } from 'src/app/service/attachment.service';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { CdTimerComponent } from 'angular-cd-timer';

// transcription

import { TranscriptionService, Transcription } from 'src/app/service/transcription.service';
import { PreviewShareAgendaComponent } from 'src/app/components/preview-share-agenda/preview-share-agenda.component';

//end transcription

@Component({
  selector: 'app-schedule-and-instant',
  templateUrl: './schedule-and-instant.component.html',
  styleUrls: ['./schedule-and-instant.component.css'],
  changeDetection: ChangeDetectionStrategy.Default,
  providers: [{ provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },

  { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
    , DatePipe]

})
export class ScheduleAndInstantComponent implements OnInit, OnDestroy {

  //for live subscription

  isRecording = false;
  isInMeeting = false;
  meetingId = '';
  userName = '';
  participants: any[] = [];
  transcriptions: any[] = [];

  private recordingSubscription: Subscription | null = null;
  private participantsSubscription: Subscription | null = null;
  private transcriptionsSubscription: Subscription | null = null;


  //End live subscription

  previousMeetingDialogBool = false;
  previousAgendaDialogBool = false;
  userAvailability: any;
  toppings = new UntypedFormControl();
  toppingList: string[] = ['Agenda 1', 'Agenda 2', 'Agenda 3', 'Agenda 4', 'Agenda 5'];
  //today Meeting Date variable 
  todayMeeting: any
  private readonly notifier!: NotifierService;
  //meeting end
  meetingEnded = false;
  showCkEditorPanel = false;
  meetingTitleEdit!: string;
  meetingDateStr: any;
  duration: any;
  meetingStartTime: any;
  //UI changes
  dateChangeContent: any;
  minuteChangeContent: any;
  secondsChangeContent: any
  paneDirection = false;
  pinDialogTriggered = false
  curPkMomDetailId: any;
  options: any
  today: any
  currentDate: any
  isAllMomApproved = false;
  //accordion opener variable
  sectionOpener: any
  participantExpansion = true;
  isLoading: boolean = false;
  speechContent: any;
  //instant meeting started variable
  meetingStarted = false;
  @Input() instantMeetingStarted = false;
  instantMeetingTriggeredFromDropDown = false
  @ViewChild(InstantMeetingDescriptionComponent) insDescpComp !: InstantMeetingDescriptionComponent;
  //two pane
  rightPane = 0;
  leftPane = 100;
  videoPane = 40;
  checker: any;
  guestFromLink: any;
  oneTimeScrollVideo = false;
  showLeftVideo = false;
  showSideToggle: boolean = true;

  prevAgendaInfoList: any;
  //pin div dialog
  pinDialogOpener = false
  pinDiv = false
  collabMeetingDetails = <MeetingCollabDetails>{};
  mediaSub!: Subscription;
  deviceXs!: boolean;
  deviceSm!: boolean;
  deviceMd!: boolean;
  deviceLg!: boolean;
  deviceXl!: boolean;

  disabled = false;
  compact = true;
  invertX = false;
  invertY = false;
  meetingType: any;
  @Input() meetingResponse!: MeetingResponse;
  meetingTypeResponse!: CodeList;
  meetingMediumResponse!: CodeList;
  meetingTitle: any;
  meetingTitleChanges: any;
  meetingJSON: any;
  scheduleMsg: string = "";
  meetingRespDiffer: any;
  momList: any[] = [];
  showMomVariable = false
  meetingTypeChecker: any;
  speechToTextToggle = false
  isTaskUpdated$ = new Subject<any>();
  isTaskStatusUpdated$ = new Subject<any>();
  isFetchActive: boolean = false;
  fetchSubscription: Subscription = new Subscription();
  fetchAudioIcon: boolean = false;
  showControls: boolean = false;
  mediumCodeList: any = <any>[];
  audioSpinner = false;

  matDialogCancel!: MatDialogRef<CancelMeetingPopupComponent>
  matDialogShortCut!: MatDialogRef<ShortcutDialogComponent>
  isExtraSmall: Observable<BreakpointState> = this.breakpointObserver.observe(
    Breakpoints.XSmall
  );
  isMedium: Observable<BreakpointState> = this.breakpointObserver.observe(
    Breakpoints.Medium
  )
  isSmall: Observable<BreakpointState> = this.breakpointObserver.observe(
    Breakpoints.Small
  )
  matDialogRef!: MatDialogRef<CopymeetingComponent, any>;
  selectParticiDialogRef!: MatDialogRef<ParticReviewSelectDialogComponent, any>;
  isMeetingModified: any
  showStart: boolean = true;
  requestVal: any;
  totalDuration: any;
  meetingStartTimerFlag = "Y";
  zoomMeeting: any;
  modifiedMeetingResponse: any;
  meetingTourValues = meetingTourValues
  scheduleMeetingTourValues = scheduleMeetingTourValues
  pastMeetingTourValues = pastMeetingTourValues
  meetingActualStartTime: any;
  meetingTimerVal: any;
  meetingTzName = this.globals.vShortTimeZone;
  curAgendaInfo!: any//added for view prev agenda functionality.
  draftSended: any;
  userNames: any = "";
  approvedLabel: any;
  isAnyMomApproved: any;
  approvedUserName: any;
  viewSwap = false
  minuteContentEmit: any;
  interval: any;
  showend = "Y";
  speechrights?: string;
  isToggleChecked?: boolean;
  meetingDateInVT: any;
  meetingDisplayDate: any;
  //onDestroy$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  onDestroy$: Subject<any> = new Subject<any>();
  docMeetTypeList: Number[];
  docMeetType: Number = 0;
  isMailSentCount = 0;
  showSendTask: boolean = false;
  // mediaRecorder!: MediaRecorder;
  mediaStream!: MediaStream;
  userId: Number;
  audioSource: { audioSource: SafeUrl, attachment: any }[] = [];
  activeAudioIndex: number | null = null;
  currentAudioTag: HTMLAudioElement | null = null;
  clickedMusicNoteIndex: number | null = null;
  audioContent: any;
  selectedTrack: boolean = true;
  found: boolean = false;
  meetTimeZoneName: any;
  audioNotFound = false;
  recording = false;
  private intervalId: any;
  extendedAgendaduration: any;
  record: any;
  flattenedDTOs?: agendaList[] = []; // Flattened array of DTOs
  groupedDTOs?: agendaList[] = []; // Array to store grouped DTOs
  agendaResponse: any;
  @HostListener('document:fullscreenchange', ['$event'])
  dragDialogRef!: MatDialogRef<DragDialogComponent, any>;
  timerTrackerArray: number[] = [];
  @HostListener('document:fullscreenchange', ['$event'])
  screenChange(event: any) {

    if (!this.sideNav.returnVideoFullScreenExpansionSetter()) {
      // this.swapView()
      document.getElementById('video-toggler')?.classList.remove('pointer-events-none')
      document.querySelectorAll('.as-split-gutter').forEach((x, index) => {

        x.classList.remove('pointer-events-none')
      })
    }
    else {
      if (this.viewSwap) {


        this.viewSwap = false
        this.swapView()
      }
      // this.swapView()
      document.getElementById('video-toggler')?.classList.add('pointer-events-none')
      document.querySelectorAll('.as-split-gutter').forEach((x, index) => {
        x.classList.add('pointer-events-none')
      })
    }
  }

  constructor(private ngZone: NgZone, private permissionService: PermissionService, private userService: UserService, private readonly breakpointObserver: BreakpointObserver, public datepipe: DatePipe, public serviceToCheck: FreeFormMinutesService, private dialog: MatDialog, public sideNav: SideNavServiceService,
    private router: Router, private globals: Globals, public mediaObserver: MediaObserver, private activatedroute: ActivatedRoute, private meetingService: MeetingService, public cdr: ChangeDetectorRef, private commonService: FreeFormAgendaService, private utilityService: UtilityService, private attendeeService: AttendeeService, private notifierService: NotifierService, private spinner: NgxSpinnerService, private differs: KeyValueDiffers,
    private websocketService: WebsocketService, private webTranService: WebsocketTransferService, private momService: MomService, private attachment: AttachmentService, private sanitizer: DomSanitizer,
    private transcriptionService: TranscriptionService) {

    this.commonService.meetTime$.subscribe(resp => {
      this.secondsChangeContent = resp;
    });

    let count = 0;
    this.agendaResponse = commonService.agendaRes.subscribe((req: any) => {
      if (count != 0) {
        this.flattenedDTOs = req;
        this.rebuildHierarchy();
      }
      count = 1;
    })
    this.speechrights = localStorage.getItem("isSpeechEnabled") || "N";
    this.userId = Number(localStorage.getItem('userId'));
    this.speechrights = localStorage.getItem("isSpeechEnabled") || "N";
    // window['angularComponentReference'] = { component: this, zone: this.ngZone, loadAngularFunction: (meetingid:any,conversationid:any) => this.funcall(meetingid,conversationid), };
    // window['speechContentUpdate'] = { component: this, zone: this.ngZone, callSpeechUpdate: () => this.saveSpeechContent()};
    // window['initializeContent'] = { component: this, zone: this.ngZone, initializeValue: (meetingid:any) => this.initializeSpeechContent(meetingid) };
    // window['hideSpinner'] = { component: this, zone: this.ngZone, callEndSpinner: () => this.hideSpinner(), };
    this.momList = [];
    this.isToggleChecked = false;
    this.showend = 'Y';
    this.serviceToCheck.setActivateCkEditor(false)
    this.meetingRespDiffer = this.differs.find({}).create();
    this.notifier = notifierService;
    this.guestFromLink = localStorage.getItem('isGuest');
    this.spinner.show();
    this.activatedroute.queryParams.subscribe(
      (response: any) => {
        if (response.meetingResult != null && response.meetingResult != undefined) {
          var meetingInfo = JSON.parse(response.meetingResult);
          this.requestVal = JSON.parse(response.meetingResult);
          this.meetingTitleChanges = null;
          this.dateChangeContent = null;
          this.minuteChangeContent = null;
          this.secondsChangeContent = null;
          //UI Team Changes
          this.meetingEnded = meetingInfo.showMoM
          if (this.meetingEnded == true) {
            this.meetingStarted = true
          }
          if (meetingInfo.showMoM == true) {
            this.showMomVariable = meetingInfo.showMoM
            this.sideNav.setTourStatusChecker('past')
          }
          this.meetingResponse = meetingInfo;
          this.meetingTypeResponse = meetingInfo;
          this.fetchAndAssignMeetingInfo(meetingInfo);
          this.todayMeeting = new Date(this.meetingResponse.meetingDateFullFormat).toDateString()
          ////consolee.log("today meeting",this.todayMeeting)
          //code added for showing start button flag

          this.meetingService.initializeWebSocketConnection(this.meetingResponse.meetingId);
          this.transcriptionService.initializeWebSocketConnection(this.meetingResponse.meetingId);
          this.websocketService._connectAudio();
          this.transcriptionService.clearTranscriptions();
          this.isInMeeting = true;

          this.participantsSubscription = this.meetingService.getParticipants().subscribe(
            participants => {
              this.participants = participants;
            }
          );
          this.transcriptionsSubscription = this.transcriptionService.getTranscriptions().subscribe(
            transcriptions => {

              this.transcriptions = transcriptions;
              this.updateTranscriptionsText();
            }
          );
          this.transcriptionService.getSpeechContent(this.meetingResponse.meetingId);

        }
      }
    );
    this.commonService.observeCollabMeetingInfo()?.pipe(takeUntil(this.onDestroy$)).subscribe((value: any) => {

      if (value != undefined) {
        if (value.collabType == "ENDMEETING") {

          this.meetingEnded = true
          this.isToggleChecked = false;

          this.sideNav.openInstantMeeting(false);
          var sucMes = 'Meeting Ended By ' + value.sentByUserName;
          this.notifier.show({
            type: 'success',
            message: sucMes
          });
          //this.meetingResponse.meetingEndFlag="Y";
          value.collabType = "";
        } else if (value.collabType == "STARTMEETING") {
          this.sideNav.openInstantMeeting(true)
          this.participantExpansion = true
          this.instantMeetingStarted = !this.instantMeetingStarted
          this.rightPane = 0;
          this.leftPane = 100;
          this.meetingStarted = true
          //this.meetingResponse.meetingStartFlag="Y";
          this.meetingResponse.elementType = "";
          value.collabType = "";
        } else if (value.collabType == "MEETING") {
          if (this.meetingResponse != undefined && value != undefined && value.meetingId == this.meetingResponse.meetingId) {

            // this.meetingResponse[value.fieldName]=value.fieldValue;
            this.meetingTitleChanges = this.meetingResponse.meetingTitle;
            if (this.meetingResponse.meetingTitle != undefined) {
              this.meetingTitleEdit = this.meetingTitleChanges;
            }
            this.insDescpComp.ngOnChanges();
          }
        }
        else if (value.collabType == "MEETINGDATEANDTIME") {

          if (this.meetingResponse != undefined && value != undefined && value.meetingId == this.meetingResponse.meetingId) {
            this.meetingResponse = value.fieldValue;
            this.minuteContentChanger(this.meetingResponse);
            this.secondsContentChanger(this.meetingResponse.duration);

            this.insDescpComp.ngOnChanges();
          }
        }
      }
    });
    this.commonService.observeConversation()?.pipe(takeUntil(this.onDestroy$)).subscribe((value: any) => {
      //var name=localStorage.getItem("userName")
      //name=name!.replace(" ","")
      //joinConversationButton(environment.subscriptionKey,value.conversationId,environment.speechLanguage,"Test")  
      if (value.convStatus == "started") {

        this.speechContent = "";
        this.startOrJoinConversation(value);
      } else {

        //this.leaveJoinedConversation();
        clearInterval(this.interval);
      }

      //this.showend='N';
    });
    attendeeService.fetchUserListSource("Y");
    this.meetingService.fetchMeetingTypeInfo().then((meetingType: any) => { this.meetingTypeResponse = meetingType });
    this.meetingService.fetchMeetingMedium().then((meetingMedium: any) => { this.meetingMediumResponse = meetingMedium });
    ////consolee.log("Schedule component meeting type", this.meetingType)
    this.draftSended = this.globals.draftSendedText;
    this.docMeetTypeList = this.globals.globalDocMeetTypeList;
    var codeDto = { parentCode: 'TZ', code: this.globals.vTimeZone }
    this.meetingService.getTZNameByCode(codeDto).subscribe(responsedata => {
      this.meetTimeZoneName = responsedata.body.description
    })
  }

  rebuildHierarchy() {

    // Initialize a map to store DTOs by id for quick lookup
    const dtoMap: { [id: number]: agendaList } = {};
    if (this.flattenedDTOs != undefined) {
      for (let j = 0; j < this.flattenedDTOs.length; j++) {
        let numIndex: number = +this.flattenedDTOs[j].agendaId;
        dtoMap[numIndex] = this.flattenedDTOs[j];

      }
      this.meetingResponse.groupedAgendaList = this.flattenedDTOs?.filter(dto => !dto.parentAgendaId)

        .map(rootDto => this.buildTree(rootDto, dtoMap));
    }
  }

  buildTree(dto: agendaList, dtoMap: { [agendaId: number]: agendaList }): agendaList {
    const children = this.flattenedDTOs?.filter(child => child.parentAgendaId === dto.agendaId);

    if (children != undefined && children.length > 0) {
      dto.subtopics = children.map(child => this.buildTree(child, dtoMap));
    } else {
      dto.subtopics = [];
    }
    return dto;
  }

  conversationId: any;
  leaveJoinedConversation() {
    // leaveConversationButton(false);
  }
  initializeSpeechContent(meetingId: any) {
    return this.meetingResponse.speechToTextContent;
  }
  startOrJoinConversation(curMeetingResponse: any) {

    if (curMeetingResponse.conversationId != undefined && curMeetingResponse.conversationId != 'Y') {
      var name = localStorage.getItem("userName")
      name = name!.replace(" ", "")
      joinConversationButton(environment.subscriptionKey, curMeetingResponse.conversationId, environment.speechLanguage, name)
      this.speechToTextToggle = true
      this.interval = setInterval(() => {

        this.speechContent = innerHTML;
        var textarea = document.getElementById("speechArea");
        textarea!.scrollTop = textarea!.scrollHeight;

      }, 2000)
      this.showend = 'N';
    } else if (curMeetingResponse.conversationId == undefined && this.speechrights == 'Y') {

      /*name=localStorage.getItem("userName")
      name=name!.replace(" ","")
      startConversationButton(environment.subscriptionKey,environment.country,environment.speechLanguage,name,curMeetingResponse.meetingId);  */
    }
  }
  toggleConversation(event: any, respMeetingId: any) {

    if (event != null && event.checked == true) {
      this.startSpeechToTextRecording(this.meetingResponse.meetingId);

    } else {
      this.spinner.show();
      this.isToggleChecked = false;
      if (this.speechToTextrecord != undefined || this.speechToTextrecord != null) {
        this.speechToTextrecord.stop(this.processRecording.bind(this));
        this.speechToTextrecord = null;
        if (this.speechToTextScreenStream) {
          this.speechToTextScreenStream.getTracks().forEach(track => {
            if (track.readyState === 'live') {
              track.stop();
            }
          });
          this.speechToTextScreenStream = null;
          clearInterval(this.speechToTextinterval);

          // clear reference
          this.spinner.hide();

        }
      }
    }

  }
  endConversation() {
    //this.showend="Y"
    var meetingJson = {
      "speechToTextContent": innerHTML,
      "conversationId": "Y",
      "userId": localStorage.getItem("userId")
    }
    this.meetingService.updateMeetingConversation(this.meetingResponse.meetingId, meetingJson).subscribe(responsedata => {

    })
    // leaveConversationButton(true);
    var jsonObj = { "meetingId": this.meetingResponse.meetingId, "elementType": "speechToText", "convHostId": this.meetingResponse.convHostId, "conversationId": this.meetingResponse.conversationId, "convStatus": "ended", "meetingTypeVal": this.meetingResponse.meetingType != undefined && this.meetingResponse.meetingType != null && this.meetingResponse.meetingType != "" ? this.meetingResponse.meetingType : '' }
    this.webTranService.pushMesssageToProducer(this.meetingResponse.meetingId, jsonObj).subscribe((data) => {
    });
    clearInterval(this.interval);
  }
  saveSpeechContent() {

    let meetingSpeechContent: any = {};
    meetingSpeechContent = {
      "speechToTextContent": innerHTML,
      "meetingId": this.meetingResponse.meetingId,
      "userId": localStorage.getItem("userId")
    }
    if (this.meetingResponse.convHostId != undefined && this.meetingResponse.convHostId == localStorage.getItem("userId")) {

      this.meetingService.updateMeetingSpeechContent(this.meetingResponse.meetingId, meetingSpeechContent).subscribe(responsedata => {
        this.meetingResponse.convHostId = responsedata.body.convHostId
        this.meetingResponse.conversationId = responsedata.body.conversationId
        this.meetingResponse.speechToTextContent = responsedata.body.speechToTextContent;

      })
    }
  }

  funcall(meetingid: any, conversationid: any) {
    this.spinner.hide();
    let meetingJson = {
      "conversationId": conversationid,
      "userId": localStorage.getItem("userId"),
      "speechToTextContent": innerHTML
    }
    this.meetingService.updateMeetingConversation(meetingid, meetingJson).subscribe(responsedata => {

      this.meetingResponse.convHostId = responsedata.body.convHostId;
      this.meetingResponse.conversationId = responsedata.body.conversationId;
    })
    /**code to allow existing users to join */
    var jsonObj = { "meetingId": this.meetingResponse.meetingId, "elementType": "speechToText", "convHostId": this.meetingResponse.convHostId, "conversationId": conversationid, "convStatus": "started" }
    this.webTranService.pushMesssageToProducer(this.meetingResponse.meetingId, jsonObj).subscribe((data) => {
    });

  }

  hideSpinner() {
    this.spinner.hide();
  }

  ngOnChanges(changes: SimpleChanges) {



  }
  hideVideoPane(number: any) {
    this.videoPane = number
    if (this.videoPane != 0) {
      this.showLeftVideo = false
      this.sideNav.setVideoPaneOpenCloseStatus(false)
      document.querySelectorAll('.as-split-gutter').forEach((x, index) => {

        x.classList.remove('pointer-events-none')
      })
    }
    else if (this.videoPane == 0) {
      this.showLeftVideo = true
      this.sideNav.setVideoPaneOpenCloseStatus(true)
      document.querySelectorAll('.as-split-gutter').forEach((x, index) => {

        x.classList.add('pointer-events-none')
      })
    }
  }

  //pin dialog function

  pinDialog() {
    this.pinDiv = !this.pinDiv
    // this.pinDiv = true
    if (this.pinDiv == true) {
      this.sideNav.BackDropEnabler(false)
      this.rightPane = 50
      this.leftPane = 50
    }
    else {
      this.leftPane = 100
      this.rightPane = 0
      this.sideNav.BackDropEnabler(true)
    }
  }

  // view swap video and
  swapView() {
    if (!this.sideNav.returnVideoFullScreenExpansionSetter()) {
      this.viewSwap = !this.viewSwap
    }
    else {
      this.viewSwap = false
    }
    // this.viewSwap = !this.viewSwap
    const zoomMinutesContainer = document.getElementById('zoom-minutes-container')
    const pContainer = document.getElementById('p-container')
    const containerPane = document.getElementById('container-pane')
    const videoContainer = document.getElementById('video-container')
    if (this.viewSwap) {


      pContainer?.appendChild(containerPane!)
      videoContainer?.appendChild(zoomMinutesContainer!)
    }
    else {
      pContainer?.appendChild(zoomMinutesContainer!)
      videoContainer?.appendChild(containerPane!)
    }
  }

  //pin dialog opener function

  opePinDialog($event: any) {
    this.pinDialogOpener = !this.pinDialogOpener;
    ////consolee.log("pinDialogOpener",this.pinDialogOpener)
  }

  closeRightPinOpener() {
    this.pinDialogOpener = false
    this.sideNav.BackDropEnabler(false)
    this.leftPane = 100;
    this.rightPane = 0
  }

  //UI Team changes.
  //commented below code on 14th May. Due to timezone issue
  minuteContentChanger(minutes: any) {

    this.minuteChangeContent = minutes.meetingStartTime
    this.meetingStartTime = minutes.meetingStartTime;
    if (minutes.meetingId != undefined && minutes.meetingId != null) {
      this.attendeeService.getAttendeeListById(minutes.meetingId).subscribe(data => {
        minutes.attendeeList = data.body;
        this.userAvailability = this.checkuserAvailability(minutes)
      })
    }

  }

  getCurrentStatus(status: any) {
    if (status == 'COM') {
      this.meetingEnded = true;
      this.sideNav.openInstantMeeting(false);
    }
  }

  cancelMeetingPopup(meetingId: any) {

    this.matDialogCancel = this.dialog.open(CancelMeetingPopupComponent, {

      data: {
        meetingId: meetingId.meetingId
      },
      position: {
        left: "0%"
      },
      panelClass: ['animate__animated', 'animate__slideInLeft'],
      disableClose: false,
      maxWidth: "100%",
      maxHeight: "100vh",
      width: "50%"
      // disableClose: true

    });
    const mediumDialogSubscription = this.isMedium.subscribe(size => {
      if (size.matches) {
        this.matDialogCancel.updateSize('70vw', '100vh');
      }
    })
    const smallSubscription = this.isSmall.subscribe(size => {
      if (size.matches) {
        this.matDialogCancel.updateSize('100vw', '100vh');
      }
    })
    const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
      if (size.matches) {
        this.matDialogCancel.updateSize('100vw', '100vh');
      }
      // else {
      //   this.matDialogRef.updateSize('50%', '100vh');
      // }
    });
    this.matDialogCancel.afterClosed().subscribe((data) => {
      if (data == true) {
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        this.router.onSameUrlNavigation = 'reload';
        this.router.navigate(['dashboard']);
        this.sideNav.openInstantMeeting(false);
        mediumDialogSubscription.unsubscribe()
        smallSubscription.unsubscribe()
        smallDialogSubscription.unsubscribe()
      } else {
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        this.router.onSameUrlNavigation = 'reload';
        this.sideNav.openInstantMeeting(false);
        mediumDialogSubscription.unsubscribe()
        smallSubscription.unsubscribe()
        smallDialogSubscription.unsubscribe()
      }
    });
  }

  //UI Team changes
  secondsContentChanger(seconds: any) {
    this.secondsChangeContent = seconds

    this.duration = seconds;
  }

  createZoomMeeting(event: any) {
    this.zoomMeeting = event;


  }
  //accordion opener
  getValue(data: any) {
    ////consolee.log("data to check", data )
    this.sectionOpener = data
  }

  beforeStartMeeting(meetinObj: any, event: any) {
    if (this.utilityService.nvl(this.insDescpComp.selectedFrequency) != "" && this.insDescpComp.selectedFrequency != 'N' && this.meetingResponse.recurDetailsId == null) {
      if (this.utilityService.nvl(this.insDescpComp.recurTillDateStr.value) != "") {
        this.insDescpComp.updateTillDate(meetinObj.meetingId).then(() => {
          this.createRecurParentMeeting(meetinObj.meetingId).then(() => {
            this.startMeeting(meetinObj.meetingId);
          });
        });
      } else {
        this.insDescpComp.recurTillDateStr.markAsTouched();//([Validators.required]);
      }
    } else {
      this.startMeeting(meetinObj.meetingId);
    }
    event.preventDefault();
    event.stopPropagation();
  }

  startMeeting(meetingId: any) {
    const jsonObj = {
      "meetingId": meetingId,
      "userId": localStorage.getItem("userId")
    };

    const closeIcon = <HTMLElement>document.getElementById('close-icon-desc');

    // closeIcon.click();

    this.meetingService.startMeeting(jsonObj).subscribe(
      (meetingRes: any) => {

        this.commonService.meetingResponse.meetingStartFlag = meetingRes.body.meetingStartFlag;
        this.sideNav.openInstantMeeting(true);
        this.router.navigate(['schedule'], {
          queryParams: { "meetingResult": JSON.stringify({ "meetingId": meetingId }) },
          skipLocationChange: true,
          replaceUrl: false
        });

        // Initialize collaboration meeting details
        this.collabMeetingDetails = <MeetingCollabDetails>{};
        this.collabMeetingDetails.collabType = 'STARTMEETING';

        const sentUserName = localStorage.getItem("userName");
        if (sentUserName) {
          this.collabMeetingDetails.sentByUserName = sentUserName;
        }

        this.collabMeetingDetails.meetingId = this.meetingResponse.meetingId;

        if (this.meetingResponse.meetingType) {
          this.collabMeetingDetails.meetTypeVal = this.meetingResponse.meetingType;
        }

        this.webTranService.pushMesssageToProducer(this.meetingResponse.meetingId, this.collabMeetingDetails).subscribe((data) => {
        });

        // Show success notification
      },
    );

    if (this.meetingResponse.zoomMeetingId == null) {
      this.sideNav.setVideoPaneOpenCloseStatus(true);
    } else {
      this.sideNav.setVideoPaneOpenCloseStatus(false);
    }
  }
  instantMeeting() {
    this.collabMeetingDetails = <MeetingCollabDetails>{};
    this.sideNav.openInstantMeeting(true)
    this.participantExpansion = true
    this.instantMeetingStarted = !this.instantMeetingStarted
    // this.sideNav.triggerMeetingAlert(this.instantMeetingStarted)
    // this.instantMeetingStarted = !this.instantMeetingStarted
    // this.rightPane = 0;
    this.leftPane = 100;
    this.meetingStarted = true
    // return this.router.navigate(['instantMeeting'])

    this.collabMeetingDetails.collabType = 'STARTMEETING';
    const sentUserName = localStorage.getItem("userName");
    if (sentUserName != null && sentUserName != undefined) {
      this.collabMeetingDetails.sentByUserName = sentUserName;
    }
    this.collabMeetingDetails.meetingId = this.meetingResponse.meetingId;
    if (this.meetingResponse.meetingType != undefined && this.meetingResponse.meetingType != null && this.meetingResponse.meetingType != "") {
      this.collabMeetingDetails.meetTypeVal = this.meetingResponse.meetingType;
    }

    this.webTranService.pushMesssageToProducer(this.meetingResponse.meetingId, this.collabMeetingDetails).subscribe((data) => {
    });

  }

  boolean = true

  ngDoCheck() {
    if (this.sideNav.openInstantMeetingTransmitter() == true) {
      this.participantExpansion = false;
      this.instantMeetingStarted = true
      // this.sideNav.triggerMeetingAlert(this.instantMeetingStarted)
      // this.instantMeetingStarted = !this.instantMeetingStarted
      // this.rightPane = 0;
      this.leftPane = 100;
      this.meetingStarted = true
      this.meetingEnded = false
      this.sideNav.setTourStatusChecker('instant')
      // 
    }
    if (this.deviceXl || this.deviceLg) {
      this.paneDirection = false
    }
    else {
      this.paneDirection = true
    }



    const dialogType = document.getElementsByClassName('cke_dialog_title');
    if (dialogType) {
      for (let i = 0; i < dialogType.length; i++) {
        if (dialogType[i].innerHTML == "Image Properties") {
          const imageBtnlabel = document.getElementsByClassName('cke_dialog_ui_button');
          if (imageBtnlabel) {
            for (let j = 0; j < imageBtnlabel.length; j++) {
              if (imageBtnlabel[j].textContent == 'Send it to the Server') {
                imageBtnlabel[j].textContent = 'Upload'
                imageBtnlabel[j].setAttribute('style', 'padding: 8px 6px;margin: 6px 8px 6px 8px;text-align: center; vertical-align: middle; cursor: pointer; min-width: 88px;  border-radius: 7px; font-size: 14px; text-align: center;text-transform: uppercase; text-decoration:none; border: none; outline: none;background-color:var(--bttn-primary) !important;color:white');
              }
              if (imageBtnlabel[j].textContent == 'OK') {
                imageBtnlabel[j].setAttribute('style', 'display : none')
              }
              if (imageBtnlabel[j].textContent == 'Cancel') {
                imageBtnlabel[j].textContent = 'close'
                imageBtnlabel[j].setAttribute('style', 'padding: 4px 8px; margin: 0;text-align: center; color: #333; vertical-align: middle; cursor: pointer; border: 1px solid #b6b6b6; border-bottom-color: #999; border-radius: 3px;box-shadow: 0 1px 0 rgb(255 255 255 / 50%), 0 0 2px rgb(255 255 255 / 15%) inset, 0 1px 0 rgb(255 255 255 / 15%) inset; background: #e4e4e4;background-image: linear-gradient(to bottom,#fff,#e4e4e4);')

              }
            }
          }
        } else {
          const imageBtnlabel = document.getElementsByClassName('cke_dialog_ui_button');
          if (imageBtnlabel) {
            for (let j = 0; j < imageBtnlabel.length; j++) {
              if (imageBtnlabel[j].textContent == 'OK') {
                imageBtnlabel[j].setAttribute('style', 'display : block;border: none; outline: none;background-color:var(--bttn-primary) !important;color:white;');
              }
              /*if (imageBtnlabel[j].textContent == 'Cancel') {
                imageBtnlabel[j].textContent = 'Close'
                imageBtnlabel[j].setAttribute('style', 'border: none; outline: none;background-color:var(--bttn-primary) !important;color:white;')

              }*/
            }
          }
        }
      }
    }
    const imageText = document.getElementsByClassName('cke_dialog_ui_labeled_label');
    for (let i = 0; i < imageText.length; i++) {
      if (imageText[i]) {
        //imageText[i].textContent = 'Select a file to upload'
      }
    }
    // if(this.serviceToCheck.returnActivateCkEditor() == true){
    //   this.showCkEditorPanel = true

    // }

    // else{
    //   if(this.meetingResponse.commonMomStatusCode!=undefined && this.meetingResponse.commonMomStatusCode==environment_const.momApproveStatus){
    //     this.sideNav.disablePageAfterApproval();
    //   }else{
    //     this.sideNav.enableAfterApproveToNormal();
    //   }
    // }
    if (this.pinDialogTriggered && this.oneTimeScrollVideo) {
      if (document.getElementById('pane-vid')) {
        document.getElementById('pane-vid')?.scrollIntoView()
        this.oneTimeScrollVideo = false
      }
      // else{
      setTimeout(() => {
        this.oneTimeScrollVideo = false
      }, 500)
      // }
    }

  }



  //UI Team Change
  closeInstantMeeting(meetingResponse: any) {
    this.collabMeetingDetails = <MeetingCollabDetails>{};
    var msg = environment_msg.msg_confirm_endmeeting;

    this.docMeetTypeList.forEach((meetType: any) => {
      if (meetType == meetingResponse.meetingType) {
        this.found = true;
        msg = environment_msg.msg_confirm_docEndmeeting;
      }
      if (this.found != true) {
        msg = environment_msg.msg_confirm_endmeeting;
      }
    });

    this.dialog.open(ConfirmDialogComponent, {
      data: {
        dialogTitle: "Confirmation",
        dialogContent: msg
      },
    }).afterClosed().subscribe(response => {
      if (response) {

        if (this.meetingResponse.convHostId == localStorage.getItem("userId")) {
          // leaveConversationButton(true);
        } else {
          // leaveConversationButton(false);

        }
        this.isToggleChecked = false;
        clearInterval(this.interval);
        if (this.speechToTextrecord != undefined || this.speechToTextrecord != null) {
          this.speechToTextrecord.stop(this.processRecording.bind(this));
          this.speechToTextrecord = null;
          if (this.speechToTextScreenStream) {
            this.speechToTextScreenStream.getTracks().forEach(track => {
              if (track.readyState === 'live') {
                track.stop();
              }
            });
            this.speechToTextScreenStream = null;
            clearInterval(this.speechToTextinterval);
          }
        }
        var reqJson = { "meetingId": meetingResponse.meetingId, "userId": this.globals.userId, "visitorTimeZone": this.globals.vTimeZone };
        this.spinner.show();
        this.isLoading = true;
        this.meetingService.endMeeting(reqJson).subscribe(
          (meetingRes: any) => {
            ////consolee.log("meeting resp frm end meeting" + JSON.stringify(meetingRes));
            meetingRes.body.agendaList.forEach((element: any) => {
              if (document.getElementById('pauseTimer' + element.agendaId) != undefined) {
                document.getElementById('pauseTimer' + element.agendaId)?.click();
              }
              if (document.getElementById('playTimer' + element.agendaId) != undefined) {
                document.getElementById('pauseTimer' + element.agendaId)?.click();
              }
            });
            this.notifier.show({
              type: 'success',
              message: 'Meeting Ended Successfully'
            });

            // this.meetingResponse = meetingRes.body;
            //this.commonService.shareDatatoService(this.meetingResponse);
            if (meetingRes != null && meetingRes.body != null) {
              this.meetingResponse.meetingStatusCode = meetingRes.body.meetingStatusCode;
              this.meetingResponse.pkMomDetailId = meetingRes.body.pkMomDetailId;
              this.momList = meetingRes.body.momDetailList;
              this.curPkMomDetailId = meetingRes.body.pkMomDetailId;
              //this.meetingResponse.meetingEndFlag=meetingRes.body.meetingEndFlag;
            }
            this.meetingEnded = true
            this.sideNav.openInstantMeeting(false);
            this.sideNav.setTourStatusChecker('past')
            this.sideNav.setVideoPaneOpenCloseStatus(true)
            this.viewSwap = true;
            this.swapView();
            this.pinDialogTriggered = false
            this.collabMeetingDetails.collabType = 'ENDMEETING';
            const sentUserName = localStorage.getItem("userName");
            if (sentUserName != null && sentUserName != undefined) {
              this.collabMeetingDetails.sentByUserName = sentUserName;
            }
            this.collabMeetingDetails.meetingId = this.meetingResponse.meetingId;
            if (this.meetingResponse.meetingType != undefined && this.meetingResponse.meetingType != null && this.meetingResponse.meetingType != "") {
              this.collabMeetingDetails.meetTypeVal = this.meetingResponse.meetingType;
            }

            this.webTranService.pushMesssageToProducer(this.meetingResponse.meetingId, this.collabMeetingDetails).subscribe((data) => {
            });
          },
          err => {

            //this.ngxSpinner.hide();
          }).add(() => {
            this.spinner.hide();
            this.isLoading = false;
          });
      }
    });
  }

  booleanEmit(event: any) {
    this.meetingEnded = event
  }
  checkAllMomApproved() {
    this.isAllMomApproved = true;
    if (this.momList != undefined && this.momList != null && this.momList.length > 0) {
      this.momList.forEach((element: any) => {
        if (element != null && element.momStatusCode != null && element.momStatusCode != undefined && (element.momStatusCode != environment_const.momApproveStatus)) {
          this.isAllMomApproved = false;
          return;
        }
      });
    } else {
      this.isAllMomApproved = false;
    }
  }

  // checkIsAnyMomApproved(){
  //   this.isAnyMomApproved=false;
  //   if(this.momList!=undefined && this.momList!=null && this.momList.length>0){
  //     this.momList.forEach((element:any) => {
  //       if(element!=null && element.momStatusCode!=null && element.momStatusCode!=undefined && (element.momStatusCode==environment_const.momApproveStatus)){
  //         this.isAnyMomApproved=true;
  //         return;
  //       }
  //     });
  //   }
  // }

  //openPreviewSelectedParticipantsDialog()
  openPreviewSelectedParticipantsDialog() {

    const roleFlag = this.permissionService.checkRoleRightsWithAlert(this.utilityService.featureList.MINUTES, this.utilityService.permissionType.MODIFY);

    if (!roleFlag) {
      return;
    }

    this.momService.fetchAgendaMinutesCount(this.meetingResponse.meetingId).subscribe((resp: any) => {

      if (resp != null && resp != undefined && resp.count != undefined && resp.count <= 0) {

        this.notifier.show({
          type: 'error',
          message: environment_msg.msg_error_enter_notes_to_draft
        });
        return false;
      } else if (this.momList == null || this.momList == undefined || this.momList.length <= 0) {
        // this.notifier.show({
        //   type: 'error',
        //   message: environment_msg.msg_error_create_mom
        // });
        this.fetchMoMDetailListByMeeting().then(() => {
          this.callReviewDraftDialog();
        });
      } else {
        this.callReviewDraftDialog();
      }
      return true;
    });
    return true;
  }
  callReviewDraftDialog() {

    const roleFlag = this.permissionService.checkRoleRightsWithAlert(this.utilityService.featureList.MINUTES, this.utilityService.permissionType.MODIFY);
    if (!roleFlag) {
      return;
    }

    this.checkAllMomApproved();
    if (this.momList == null || this.momList == undefined || this.momList.length <= 0) {
      this.notifier.show({
        type: 'error',
        message: environment_msg.msg_error_create_mom
      });
      return false;
    } else if (this.isAllMomApproved) {
      this.notifier.show({
        type: 'error',
        message: environment_msg.msg_error_mom_already_approved
      });
      return false;
    } else {
      const reviewSelect = this.dialog.open(ParticReviewSelectDialogComponent, {
        data: {
          title: "Participants Review Selection", curPkMoMDetailId: this.curPkMomDetailId, momList: this.momList, generateNewCon: "Y",
          meetingResp: this.meetingResponse
        },
        panelClass: ['animate__animated', 'animate__slideInLeft'],
        disableClose: true,
        position: {
          left: "0%"
        },
        maxWidth: "70%",
        maxHeight: "100vh",
        width: "50%",
        height: "100vh"
      });
      const mediumDialogSubscription = this.isMedium.subscribe(size => {
        if (size.matches) {
          reviewSelect.updateSize('70vw', '100vh');
        }
      })
      const smallSubscription = this.isSmall.subscribe(size => {
        if (size.matches) {
          reviewSelect.updateSize('100vw', '100vh');
        }
      })
      const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
        if (size.matches) {
          reviewSelect.updateSize('100vw', '100vh');
        }
      });
      reviewSelect.afterClosed().subscribe((data: any) => {
        mediumDialogSubscription.unsubscribe()
        smallSubscription.unsubscribe()
        smallDialogSubscription.unsubscribe()
        this.fetchMoMDetailListByMeeting();
      });
    }
    return;
  }

  //openMoMSelectApprovalDialog()
  openMoMSelectApprovalDialog() {

    this.momService.fetchAgendaMinutesCount(this.meetingResponse.meetingId).subscribe((resp: any) => {

      if (resp != null && resp != undefined && resp.count != undefined && resp.count <= 0) {

        this.notifier.show({
          type: 'error',
          message: environment_msg.msg_error_enter_notes_to_approve
        });
        return false;
      } else if (this.momList == null || this.momList == undefined || this.momList.length <= 0) {
        // this.notifier.show({
        //   type: 'error',
        //   message: environment_msg.msg_error_create_mom
        // });
        this.fetchMoMDetailListByMeeting().then(() => {
          this.callMomApproveDialog();
        });
      } else {
        this.callMomApproveDialog();
      }
      return true;
    });
    return true;
  }
  callMomApproveDialog() {
    this.checkAllMomApproved();
    if (this.momList == null || this.momList == undefined || this.momList.length <= 0) {
      this.notifier.show({
        type: 'error',
        message: environment_msg.msg_error_create_mom
      });
      return;
    }
    else if (this.isAllMomApproved) {
      this.notifier.show({
        type: 'error',
        message: environment_msg.msg_error_mom_already_approved
      });
      return;
    } else {
      this.selectParticiDialogRef = this.dialog.open(ParticReviewSelectDialogComponent, {
        data: {
          title: "MOM Approval Selection",
          meetingResp: this.meetingResponse, curPkMoMDetailId: this.curPkMomDetailId, momList: this.momList, generateNewCon: "Y",
          reviewType: "APPROVE"
        },
        panelClass: ['animate__animated', 'animate__slideInLeft'],
        disableClose: true,
        position: {
          left: "0%"
        },
        maxWidth: "100%",
        maxHeight: "100vh",
        width: "50%",
        height: "100vh"
      });
      const mediumDialogSubscription = this.isMedium.subscribe(size => {
        if (size.matches) {
          this.selectParticiDialogRef.updateSize('70vw', '100vh');
        }
      })
      const smallSubscription = this.isSmall.subscribe(size => {
        if (size.matches) {
          this.selectParticiDialogRef.updateSize('100vw', '100vh');
        }
      })
      const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
        if (size.matches) {
          this.selectParticiDialogRef.updateSize('100vw', '100vh');
        }
      });
      this.selectParticiDialogRef.afterClosed().subscribe((data: any) => {

        mediumDialogSubscription.unsubscribe()
        smallSubscription.unsubscribe()
        smallDialogSubscription.unsubscribe()
        this.fetchMoMDetailListByMeeting();
        if (data != null && data.momStatusCode != null) {
          this.meetingResponse.commonMomStatusCode = data.momStatusCode;
          this.sideNav.disablePageAfterApproval();
        }
      });
    }
  }
  goToMoM() {
    this.momService.fetchAgendaMinutesCount(this.meetingResponse.meetingId).subscribe((resp: any) => {

      if (resp != null && resp != undefined && resp.count != undefined && resp.count <= 0) {
        this.notifier.show({
          type: 'error',
          message: environment_msg.msg_error_enter_notes_to_mom
        });
        return false;
      } else {
        this.router.navigate(['MoM'], { queryParams: { "meetingResult": JSON.stringify(this.meetingResponse) }, skipLocationChange: true, replaceUrl: false });
        return true;
      }
    });
    //this.router.navigate(['MoM'], { queryParams: { "meetingResult": JSON.stringify( {"meetingId" : this.meetingResponse.meetingId,"meetingTitle":this.meetingResponse.meetingTitle,"meetingDate":this.meetingResponse.meetingDateFullFormat,"timezone":this.meetingResponse.tzName,"duration":this.meetingResponse.duration,"meetingTime":this.meetingResponse.meetingStartTime }) }, skipLocationChange: true, replaceUrl: false });  
    return true;
  }

  previewMinutesDialog(meetingResp: any) {
    const roleFlag = this.permissionService.checkRoleRightsWithAlert(this.utilityService.featureList.MINUTES, this.utilityService.permissionType.MODIFY);

    if (!roleFlag) {
      return;
    }
    //check note count
    this.momService.fetchAgendaMinutesCount(this.meetingResponse.meetingId).subscribe((resp: any) => {

      if (resp != null && resp != undefined && resp.count != undefined && resp.count <= 0) {
        this.notifier.show({
          type: 'error',
          message: environment_msg.msg_error_enter_notes_to_preview
        });
        return false;
        //check empty mom list
      } else if (this.momList == null || this.momList == undefined || this.momList.length <= 0) {
        // this.notifier.show({
        //   type: 'error',
        //   message: environment_msg.msg_error_create_mom
        // });
        this.fetchMoMDetailListByMeeting().then(() => {
          this.callPreviewDialog(meetingResp);
        });
      }
      else {
        this.callPreviewDialog(meetingResp);
      }
      return true;
    });
    return true;
  }

  callPreviewDialog(meetingResp: any) {
    this.checkAllMomApproved();
    if (this.momList == null || this.momList == undefined || this.momList.length <= 0) {
      this.notifier.show({
        type: 'error',
        message: environment_msg.msg_error_create_mom
      });
      return;
    } else if (this.isAllMomApproved) {
      this.notifier.show({
        type: 'error',
        message: environment_msg.msg_error_mom_already_approved
      });
      return;
    } else {

      const previewMinutes = this.dialog.open(PreviewMinutesDialogComponent, {
        data: { meetingInfo: meetingResp, momList: this.momList, generateNewCon: "Y", curPkMoMDetailId: this.curPkMomDetailId },
        panelClass: ['parent-dialog-container'],
        maxWidth: "100%",
        maxHeight: "100vh",
        width: "80%",
        height: "100vh"
      })
      const mediumDialogSubscription = this.isMedium.subscribe(size => {
        if (size.matches) {
          previewMinutes.updateSize('70vw', '100vh');
        }
      })
      const smallSubscription = this.isSmall.subscribe(size => {
        if (size.matches) {
          previewMinutes.updateSize('100vw', '100vh');
        }
      })
      const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
        if (size.matches) {
          previewMinutes.updateSize('100vw', '100vh');
        }
        // else {
        //   this.matDialogRef.updateSize('50%', '100vh');
        // }
      });
      previewMinutes.afterClosed().subscribe((data) => {
        this.fetchMoMDetailListByMeeting();
        mediumDialogSubscription.unsubscribe()
        smallDialogSubscription.unsubscribe()
        smallSubscription.unsubscribe()
      });
    }
  }

  dateContentChanger(value: any) {

    this.dateChangeContent = value
    var meetingDate = this.datepipe.transform(value, "MMM dd, YYYY");

    this.meetingDateStr = meetingDate;
    var meetUTCDate = new Date(this.meetingDateStr);
    var todayDate = new Date();

    if (meetUTCDate.getUTCDate() > todayDate.getUTCDate()) {
      this.showStart = false;
    } else {
      this.showStart = true;
    }
  }

  ngAfterViewInit() {

    this.mediaSub = this.breakpointObserver.observe([
      Breakpoints.XSmall,
      Breakpoints.Small,
      Breakpoints.Medium,
      Breakpoints.Large,
      Breakpoints.XLarge
    ]).subscribe(result => {
      const breakpoints = result.breakpoints;

      this.deviceXs = breakpoints[Breakpoints.XSmall] || false;
      this.deviceSm = breakpoints[Breakpoints.Small] || false;
      this.deviceMd = breakpoints[Breakpoints.Medium] || false;
      this.deviceLg = breakpoints[Breakpoints.Large] || false;
      this.deviceXl = breakpoints[Breakpoints.XLarge] || false;
    });

    // var reqJSON = {
    //   "userId":localStorage.getItem("userId"),
    //   "meetingId":this.meetingResponse.meetingId,
    //   "orgCode":localStorage.getItem("orgCode"),
    //   "reportingUserId":this.globals.repotingUsers
    //   }
    //  this.userService.fetchUserMeetingRoleRights(reqJSON).subscribe((roleRightsMap: any)=>{ this.globals.roleRightsMap = roleRightsMap });
    this.fetchMoMDetailListByMeeting().then(() => {


    });
    setTimeout(() => {
      if (this.guestFromLink != undefined && this.guestFromLink != null && this.guestFromLink == '1') {
        this.sideNav.disablePages();
      }
    }, 50)
  }

  ngOnInit(): void {
    this.sideNav.meetingStarted.next(this.meetingStarted);
    let approvalFlag = true;
    this.momService.fetchMoMDetailListByMeeting(this.meetingResponse.meetingId).subscribe(res => {
      if (res.body != null && res.body != undefined) {

        this.momList = res.body;
        this.momList.forEach((elem: any) => {


          if (elem.momStatusCode == environment_const.momApproveStatus && approvalFlag) {
            approvalFlag = false;

            this.meetingService.getMomApprovedUserNames(this.meetingResponse.meetingId).subscribe((data: any) => {

              data.forEach((element: any) => {
                if (data.length == 1) {

                  this.approvedLabel = environment_label.label_approvedUserNames
                  if (element.user_fullname)
                    this.userNames += element.user_fullname;

                  this.approvedUserName = this.userNames;
                } else {

                  this.approvedLabel = environment_label.label_approvedUserNames
                  if (element.user_fullname)
                    this.userNames += element.user_fullname + ",";
                  this.approvedUserName = this.userNames.slice(0, -1)
                  // this.userNames.slice(0, -1)
                  //this.userNames = this.userNames.slice(0, -1);
                }
              });
            });
          }

        });
      }
    });
    // let OpenMeetingInfo = <HTMLElement>document.getElementById('OpenMeetingInfo');

    this.options = {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    }

    if (this.meetingResponse.zoomMeetingId == null) {
      this.sideNav.setVideoPaneOpenCloseStatus(true)
    }
    else {
      this.sideNav.setVideoPaneOpenCloseStatus(false)
    }
    if (this.meetingStarted == false) {
      this.sideNav.setTourStatusChecker('schedule_meeting')
    }


    // if(this.sideNav.openInstantMeetingTransmitter() == false){


    if (this.showMomVariable) {
      // window.alert("past meeting")
      this.showMeetingDetails();
    }
    this.today = new Date();
    this.currentDate = this.today.toLocaleDateString("en-US", this.options)


    this.commonService.taskRow$.pipe(
      takeUntil(this.isTaskUpdated$)        // <-- pipe in the `takeUntil()` here
    ).subscribe((param: any) => {
      if (param.taskVal.ismailsent == -1) {
        this.showSendTask = true;
      }
    })
    this.serviceToCheck.taskRow$.pipe(
      takeUntil(this.isTaskStatusUpdated$)        // <-- pipe in the `takeUntil()` here
    ).subscribe((param: any) => {
      if (param.taskVal.ismailsent == -1) {
        this.showSendTask = true;
      }
    })

  }

  showMeetingDetails() {
    const editIcon = (<HTMLElement>document.getElementById('edit-icon'))
    editIcon.hidden = false;
    const dateDetails = <HTMLElement>document.getElementById('date-details');
    dateDetails.hidden = false
    // editIcon.click()
    const OpenMeetingInfo = <HTMLElement>document.getElementById('OpenMeetingInfo');

    const displays = window.getComputedStyle(OpenMeetingInfo, null).display

    if (displays == 'inline') {
      $("#OpenMeetingInfo").toggle()
    }
    const meetingTitleChanger = <HTMLElement>document.getElementById('meeting-title-changer');
    meetingTitleChanger.contentEditable = 'false'
    meetingTitleChanger.style.border = '0px';
    // let meetingTitleChanger = <HTMLElement>document.getElementById('meeting-title-changer');
    // meetingTitleChanger.contentEditable = 'false'
  }

  ngOnDestroy() {
    this.agendaResponse.unsubscribe();
    this.collabMeetingDetails = <MeetingCollabDetails>{};

    if (this.websocketService != undefined && this.websocketService != null) {
      this.spinner.show();
      if (this.record != undefined && this.record != null) {
        this.record.stop(this.processRecording.bind(this));
      }
      clearInterval(this.speechToTextinterval);
      if (this.speechToTextrecord != undefined || this.speechToTextrecord != null) {
        this.speechToTextrecord.stop(this.processRecording.bind(this));
        this.speechToTextrecord = null;
        if (this.speechToTextScreenStream) {
          this.speechToTextScreenStream.getTracks().forEach(track => {
            if (track.readyState === 'live') {
              track.stop(); // this removes the red icon
            }
          });
          this.speechToTextScreenStream = null; // clear reference
        }
      }
      clearInterval(this.intervalId);
      this.websocketService._disconnectAudio();
      //for audio to text transcripe
      // this.websocketService.disconnectAudioWebSocket();
      this.meetingService.disconnectWebSocket();
      this.transcriptionService.disconnectWebsocket();
      this.leaveAudioToText();


      setTimeout(() => {
        var req = {
          meetingId: this.meetingResponse.meetingId,
          createdBy: this.meetingResponse.facilitatorId
        }
        this.attachment.mergeAudio(req).subscribe((data: any) => {
          if (data.attachmentMode == 'success') {
          }
        }, error => {
          alert(error);
        })
        this.spinner.hide();
      }, 3000);
    }

    this.collabMeetingDetails = <MeetingCollabDetails>{};
    clearInterval(this.interval)
    if (this.meetingResponse.meetingStartFlag == 'Y' && this.meetingResponse.meetingEndFlag != "Y") {
      if (this.meetingResponse.convHostId == localStorage.getItem("userId")) {
        this.endConversation();
      } else {
        // leaveConversationButton(false);
      }
    }
    this.sideNav.setTourStatusChecker('')
    this.mediaSub?.unsubscribe();
    this.insDescpComp.updateRecurFields();
    if (localStorage.getItem("userId") != null) {
      if (this.requestVal['isMeetingRunning'] != null && this.requestVal['isMeetingRunning'] != undefined && this.requestVal['isMeetingRunning'] == true) {
        const reqJson = { "meetingId": this.meetingResponse.meetingId, "userId": localStorage.getItem("userId"), "loggedStatus": "LOGOUT" }
        this.webTranService.pushUserLoggedInStatus(this.meetingResponse.meetingId, reqJson).subscribe((data) => {

          this.collabMeetingDetails.collabType = 'EXITMEETING';
          this.collabMeetingDetails.elementId = "" + this.globals.userId
          const sentUserName = localStorage.getItem("userName");
          if (sentUserName != null && sentUserName != undefined) {
            this.collabMeetingDetails.sentByUserName = sentUserName;
          }
          this.collabMeetingDetails.meetingId = this.meetingResponse.meetingId;
          if (this.meetingResponse.meetingType != undefined && this.meetingResponse.meetingType != null && this.meetingResponse.meetingType != "") {
            this.collabMeetingDetails.meetTypeVal = this.meetingResponse.meetingType;
          }

          this.webTranService.pushMesssageToProducer(this.meetingResponse.meetingId, this.collabMeetingDetails).subscribe((data) => {

            this.websocketService._disconnect();
          });

        });
      } else {
        this.websocketService._disconnect();
      }

    }
    this.globals.roleRightsMap = null;
    this.globals.roleCode = null;

    $(".disableAfterApproveCls [contenteditable=false]").attr("contenteditable", "true");
    $(document).removeClass("disableAfterApproveCls");
    this.sideNav.enableAfterApproveToNormal();
    this.onDestroy$.next();
    this.onDestroy$.complete();
    this.onDestroy$.unsubscribe();

    this.isTaskUpdated$.next();
    this.isTaskUpdated$.complete();

    this.isTaskStatusUpdated$.next();
    this.isTaskStatusUpdated$.complete();


    //for transcription

    if (this.recordingSubscription) {
      this.recordingSubscription.unsubscribe();
    }
    if (this.participantsSubscription) {
      this.participantsSubscription.unsubscribe();
    }
    if (this.transcriptionsSubscription) {
      this.transcriptionsSubscription.unsubscribe();
    }


    //end transcription

  }
  getLatestMeetingResponse(data: any) {
    this.extendedAgendaduration = data.duration
    setTimeout(() => {
      this.meetingResponse = data;
      setTimeout(() => {
        this.flattenedDTOs = data;
        // this.flattenedDTOs = this.meetingResponse.groupedAgendaList;
        // this.rebuildHierarchy();
      }, 500)
    }, 500)

  }
  leaveAudioToText(): void {
    this.meetingService.leaveAudioToText();
    this.transcriptionService.stopTranscription();
    this.isInMeeting = false;
  }
  getAgendaEmit(data: MeetingResponse) {
    setTimeout(() => {
      this.meetingResponse = data;
      setTimeout(() => {
        this.flattenedDTOs = this.meetingResponse.agendaList;
        this.rebuildHierarchy();
      }, 500)
    }, 500)
  }
  fetchMoMDetailListByMeeting() {
    return new Promise(async (resolve, reject) => {
      await this.momService.fetchMoMDetailListByMeeting(this.meetingResponse.meetingId).subscribe(res => {
        if (res.body != null && res.body != undefined) {
          this.momList = res.body;
          if (res.body[0] != undefined && res.body[0] != null) {
            this.curPkMomDetailId = res.body[0]!.pkMomDetailId;
          }
          resolve(this.momList);
        }
      });
    });
  }
  //Method to fetch and assign value to meeting interface/model
  fetchAndAssignMeetingInfo(meetingInfo: any) {
    this.meetingTitleChanges = null;
    let jsonObj: any = {};
    this.spinner.show();
    if (meetingInfo['meetingId'] != null) {
      this.attachment.downloadAudio(meetingInfo['meetingId'] + "").subscribe((data: any) => {
        if (data.body.length != 0) {
          this.audioSource = [];
          data.body.forEach((file: any) => {
            var req = JSON.parse(JSON.stringify(file));
            this.attachment.getAttachmentById(req.attachmentId).subscribe((res: any) => {
              let blobresp = res.body;
              let blob = new Blob([blobresp], { type: blobresp.type });
              var value = {
                "audioSource": this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(blob)),
                "attachment": req
              }
              this.audioSource.push(value);
            })
          })
        }
      })
      //this.ngxSpinner.show();
      if (meetingInfo['isConfidential'] == "Y") {
        jsonObj = {
          "meetingId": meetingInfo['meetingId'],
          "userId": this.globals.userId,
          "deletedFlag": 0,
          "rowStatus": "",
          "decryptKey": meetingInfo['decryptKey'],
          "visitorTimeZone": this.globals.vTimeZone,
          "meetingUTCDate": meetingInfo['meetingObj'].meetingUTCDate,
          "meetingDate": meetingInfo['meetingObj'].meetingDate,
          "meetingStartTime": meetingInfo['meetingObj'].meetingStartTime,
          "meetingDateStr": meetingInfo['meetingObj'].meetingDateStr,
          "location": meetingInfo['meetingObj'].location,
        }
        //this.isLoading=true;
        this.meetingService.fetchMeetingConfInfo(jsonObj).subscribe(
          (meetingRes: any) => {
            //alert("meetingRes::"+JSON.stringify(meetingRes));
            this.meetingInfoData(meetingRes);
            this.spinner.hide();
          },
          err => {
          }).add(() => {
            // this.spinner.hide();
          });
      }
      else {
        this.meetingService.fetchMeetingInfo(meetingInfo['meetingId']).subscribe(
          (meetingRes: any) => {
            if (meetingRes.body.meetingEndFlag == 'Y') {
              this.meetingEnded = true
              this.meetingStarted = true;
              this.sideNav.openInstantMeeting(false);
            }
            this.spinner.hide();
            if (meetingRes.body.attendeeList != undefined && meetingRes.body.agendaList != undefined) {
              let roleFlag = true;
              let rolecode: any;
              if (roleFlag) {
                meetingRes.body.attendeeList.forEach((elem: any, agIndex: any) => {
                  if (localStorage.userId == elem.fkSecUserAttendee) {
                    rolecode = elem.attendeeRole
                    roleFlag = false;
                  }
                  if (elem.attendeeIsPresent == 'N') {
                    elem.logType = 'OUT'
                  }
                });
              }
              if (roleFlag) {
                meetingRes.body.agendaList.forEach((elem: any, agIndex: any) => {
                  elem.minutesList.forEach((minEle: any, agIndex: any) => {
                    if (minEle.entityType == "AI") {
                      if (minEle.assignedTo == localStorage.userId) {
                        rolecode = "TU"
                        roleFlag = false;
                      } else {
                        const actionItemOwner = JSON.parse(minEle.assignedTo);
                        actionItemOwner.forEach((taskEle: any, agIndex: any) => {
                          if (localStorage.userId == taskEle.fkSecUserOwner) {
                            rolecode = "TU"
                            roleFlag = false;
                          }
                        });
                      }
                    }
                  });
                });

              }
              if (roleFlag) {
                const reportingUserArray = this.globals.repotingUsers.split(',');
                meetingRes.body.attendeeList.forEach((elem: any, agIndex: any) => {
                  for (let i = 0; i < reportingUserArray.length; i++) {
                    if (reportingUserArray[i] == elem.fkSecUserAttendee) {
                      rolecode = "SO";
                      roleFlag = false;
                    }
                  }
                });
              }
              const reqJson = {
                "roleCode": rolecode
              }
              this.userService.getRoleRights(reqJson).subscribe((roleRightsMap: any) => {
                this.globals.roleRightsMap = roleRightsMap.body.rightsMap;
                this.globals.roleCode = roleRightsMap.body.roleCode;

                this.meetingInfoData(meetingRes);

              });

            }
          },
          err => {
          }).add(() => {
            //this.spinner.hide();
          });
      }
    }
  }
  meetingInfoData(meetingRes: any) {
    this.collabMeetingDetails = <MeetingCollabDetails>{};
    if (meetingRes.meetingStartFlag != 'Y') {
      const resp = this.checkuserAvailability(meetingRes.body);
    }
    this.meetingResponse = meetingRes.body;
    if (this.meetingResponse.meetingStartFlag == 'Y' && this.meetingResponse.meetingEndFlag != "Y" && this.meetingResponse.conversationId != 'Y') {
      this.startOrJoinConversation(this.meetingResponse);
    }
    if ((this.meetingResponse.meetingStartFlag == 'Y' && this.meetingResponse.meetingEndFlag == "Y") || this.meetingResponse.conversationId == 'Y') {
      this.speechContent = this.meetingResponse.speechToTextContent;
    }
    this.commonService.shareDatatoService(this.meetingResponse);
    this.websocketService._connect();
    this.websocketService._connectAudio();
    this.collabMeetingDetails.collabType = 'JOINMEETING';
    this.collabMeetingDetails.elementId = "" + this.globals.userId;
    const sentUserName = localStorage.getItem("userName");
    if (sentUserName != null && sentUserName != undefined) {
      this.collabMeetingDetails.sentByUserName = sentUserName;
    }
    this.collabMeetingDetails.meetingId = this.meetingResponse.meetingId;
    if (this.meetingResponse.meetingType != undefined && this.meetingResponse.meetingType != null && this.meetingResponse.meetingType != "") {
      this.collabMeetingDetails.meetTypeVal = this.meetingResponse.meetingType;
    }
    this.webTranService.pushMesssageToProducer(this.meetingResponse.meetingId, this.collabMeetingDetails).subscribe((data) => {
    });
    if (this.meetingResponse.meetingStatusCode == 'BSCH' || this.meetingResponse.meetingStatusCode == 'SCH' && this.sideNav.openInstantMeetingTransmitter() == false) {
      this.sideNav.openInstantMeeting(false)
      document.getElementById('edit-icon')?.click()
      const editIcon = (<HTMLElement>document.getElementById('edit-icon'))
      editIcon.hidden = true
      const dateDetails = <HTMLElement>document.getElementById('date-details');
      dateDetails.hidden = true
      const OpenMeetingInfo = <HTMLElement>document.getElementById('OpenMeetingInfo');
      const displays = window.getComputedStyle(OpenMeetingInfo, null).display
      if (displays != 'inline') {
        const meetingTitleChanger = <HTMLElement>document.getElementById('meeting-title-changer');
        meetingTitleChanger.contentEditable = 'true'
      }
      const closeIcon = <HTMLElement>document.getElementById('close-icon-desc');
      //closeIcon.hidden = false;
    }
    if (this.meetingResponse.meetingUTCDate != undefined) {
      const meetUTCDate = new Date(this.meetingResponse.meetingUTCDate);
      const todayDate = new Date();
      if (meetUTCDate.getUTCDate() > todayDate.getUTCDate()) {
        this.showStart = false;
      }
    }
    if (this.meetingResponse.meetingStatusCode == 'BSCH') {
      this.mediumCodeList = this.meetingMediumResponse;
      this.mediumCodeList.forEach((obj: any, index: any) => {
        if (obj.codeId == this.meetingResponse.meetingMedium && obj.description == "Zoom") {
          this.showStart = false;
        }
      });
    }
    //close
    if (this.meetingResponse.meetingMediumDesc == 'Zoom'
      && this.meetingResponse.zoomCreateMeeting != undefined
      && this.meetingResponse.zoomCreateMeeting == 'Y') {
      if (this.meetingResponse.meetingStartFlag == 'Y' && this.meetingResponse.meetingEndFlag != 'Y') {
        this.sideNav.openInstantMeeting(true);
      }
    }
    // this.setData();

    //this.cdr.markForCheck();
    //this.ngxSpinner.hide();
    if (this.meetingResponse.meetingUTCDate != undefined) {

      const curSysDate = new Date(this.meetingResponse.meetingUTCDate);
      const meetUtc = curSysDate.getTime() + (curSysDate.getTimezoneOffset() * 60000);//current utc date with time
      const fullDate = new Date(meetUtc + (3600000 * (this.globals.vTimeZoneIntOffset)));//convert utc to corresponding timezone
      const hour = this.addZero(fullDate.getHours());
      const minutes = this.addZero(fullDate.getMinutes());
      this.meetingStartTime = hour + ":" + minutes;
      this.meetingDateInVT = new Date(fullDate);
      this.meetingDisplayDate = this.datepipe.transform(this.meetingDateInVT, 'EEEE, MMMM d, y');

    }
    if (this.meetingResponse.commonMomStatusCode != undefined && this.meetingResponse.commonMomStatusCode == environment_const.momApproveStatus) {
      this.sideNav.disablePageAfterApproval();
    }
    this.docMeetType = Number(this.meetingResponse.meetingType);

    this.meetingResponse.agendaList?.forEach(agenda => {
      agenda.minutesList?.forEach(minute => {
        if (minute.ismailsent == -1) {
          this.isMailSentCount++;
        }
      })
    });
    if (this.isMailSentCount > 0) {
      this.showSendTask = true;
    }
    setTimeout(() => {
      this.flattenedDTOs = this.meetingResponse.agendaList;
      this.rebuildHierarchy();
      // Ensure OnPush child (`app-instant-meeting-agenda`) detects the update on first load
      // by changing @Input reference and the grouped list reference.
      try {
        const grouped = Array.isArray(this.meetingResponse.groupedAgendaList)
          ? [...this.meetingResponse.groupedAgendaList]
          : [];
        this.meetingResponse = { ...this.meetingResponse, groupedAgendaList: grouped } as any;
      } catch {}
    }, 500)
  }


  //this method is used to change the meeting title
  meetingTitleChange(e: any) {
    this.meetingTitleChanges = e;
    //  
  }

  //track attendee dialog
  trackAttendeeDialog() {
    this.dialog.open(TrackAttendeeDialogComponent, {
      panelClass: "base-class-dialog",
      disableClose: false,
      maxWidth: "100%",
      maxHeight: "100vh",
      width: "95%"
    });
  }


  scheduleMeeting(meetingId: number, code: any) {
    this.spinner.show();
    if (code == 'BSCH') {
      this.meetingJSON = {
        "meetingId": meetingId,
      };
    } else {
      this.meetingJSON = {
        "meetingId": meetingId,
        "rescheduleFlag": "Y"


      }
    };
    // this.meetingJSON.meetingFrequency ="N";
    //this.meetingJSON.recurMeetingFlag ="";
    this.meetingJSON.orgCode = localStorage.orgCode;
    this.meetingJSON.orgCode = localStorage.getItem("orgCode");
    this.meetingJSON.zoomUserId = localStorage.getItem('email');
    //this.meetingJSON.zoomUserId = this.globals.settingValuesList.ZOOM_USERID;
    this.meetingJSON.zoomJWTApiKey = this.globals.settingValuesList.ZOOM_JWT_API_KEY;
    this.meetingJSON.zoomJWTApiSecret = this.globals.settingValuesList.ZOOM_JWT_SECRET_ID;
    this.meetingJSON.zoomCreateMeeting = this.zoomMeeting;
    this.meetingJSON.userId = localStorage.getItem("userId");
    this.meetingService.scheduleMeeting(this.meetingJSON).subscribe(res => {
      const resp = res.body;
      this.scheduleMsg = resp['scheduleMsg'];
      this.spinner.hide();
      if (this.scheduleMsg != null && this.scheduleMsg == "YES") {
        this.notifier.notify("success", "The meeting scheduled successfully");
      }

      this.router.navigate(['dashboard'])
    }, err => {
      this.sideNav.alertMeetingReason('Error: While scheduling the meeting', 'error');
      this.spinner.hide();
    });

  }

  beforeScheduleMeeting(meetinObj: any, code: any, event: any) {
    if (this.utilityService.nvl(this.insDescpComp.selectedFrequency) != "" && this.insDescpComp.selectedFrequency != 'N' && this.meetingResponse.recurDetailsId == null) {
      if (this.utilityService.nvl(this.insDescpComp.recurTillDateStr.value) != "" && this.utilityService.nvl(this.insDescpComp.repeatValue) != "") {

        if (this.insDescpComp.meetingFrequency.value == 'W' && this.insDescpComp.meetingDaysCheckbox
          .filter((item: any) => item.checked).length == 0) {

          return;
        }

        if (this.insDescpComp.meetingFrequency.value == 'M' && (((this.insDescpComp.day) && this.insDescpComp.repeatDayInMonthValue == undefined || 0) || ((this.insDescpComp.weekDay) && ((this.insDescpComp.repeatWeekInMonthValue == 0 || undefined) || (this.insDescpComp.repeatWeekDayInMonthValue == -1 || undefined))))) {

          return;
        }

        if (this.insDescpComp.meetingFrequency.value == 'Y' && (this.insDescpComp.monthDay && ((this.insDescpComp.repeatMonthYearValue == undefined || 0) || (this.insDescpComp.repeatDayInYearValue == undefined || 0))) || (this.insDescpComp.monthweekDay && ((this.insDescpComp.repeatYearlyInMonthValue == 0 || undefined) || (this.insDescpComp.repeatYearlyWeekValue == undefined || 0) || (this.insDescpComp.repeatYearlyWeekDayValue == -1 || undefined)))) {

          return;
        }

        var meetingDate: any = null;
        var onDate = [];
        //for weekly option
        if (this.insDescpComp.meetingFrequency.value == 'W') {
          onDate = this.insDescpComp.meetingDaysCheckbox
            .filter((item: any) => item.checked)
            .map((item: any) => item.value);
          if (!onDate.includes((new Date(this.insDescpComp.meetingDate.value)).getDay())) {
            var startDate = this.insDescpComp.meetingDate.value;
            var endDate = this.insDescpComp.recurTillDateStr.value;
            var nextDates: Date[] = [];
            onDate.forEach((day: any) => {
              var d = new Date(startDate);
              d.setDate(d.getDate() + (day + 7 - d.getDay()) % 7);
              if (new Date(startDate) < new Date(d) && new Date(endDate) >= new Date(d)) {
                nextDates.push(d);
              }
            })
            if (nextDates.length != 0) {
              nextDates.sort((a, b) => a.getTime() - b.getTime());
              meetingDate = this.datepipe.transform(nextDates[0], "MMM dd, YYYY");
              this.upDateValues(meetinObj.meetingId, meetingDate, code);

            }
            else {
              alert("no recurrsion found");
            }

          }

          //if same date means
          else {
            this.upDateValues(meetinObj.meetingId, meetingDate, code);

          }
        }


        // For monthly option
        else if (this.insDescpComp.meetingFrequency.value == 'M') {
          if (this.insDescpComp.day) {
            onDate[0] = this.insDescpComp.repeatDayInMonthValue; //Particular day
          }
          else {
            onDate[0] = this.insDescpComp.repeatWeekInMonthValue; // like first or second 
            onDate[1] = this.insDescpComp.repeatWeekDayInMonthValue;// particular day (sunday,monday)
          }
          var jsonOb = {
            startDate: this.insDescpComp.meetingDate.value,
            endDate: new Date(String(this.insDescpComp.recurTillDateStr.value)),
            visitorTimeZone: this.globals.vTimeZone,
            frequentVal: this.insDescpComp.repeatValue,
            onDate: onDate
          }

          //If particular day means like (01,02,...)
          if (onDate.length == 1) {
            if (jsonOb.startDate.getDate() != onDate[0]) {
              jsonOb.frequentVal = onDate[0] > jsonOb.startDate.getDate() ? 0 : 1;
              this.meetingService.monthlyMeetingStartDate(jsonOb).subscribe((data: any) => {
                if (data.body != null) {
                  //update meeting date here as data.body value
                  meetingDate = this.datepipe.transform(data.body, "MMM dd, YYYY");
                  this.upDateValues(meetinObj.meetingId, meetingDate, code);
                }
                else {
                  alert("no recurssion found");
                }
              })
            }
            // if same date means 
            else {
              this.upDateValues(meetinObj.meetingId, meetingDate, code);

            }
          }
          // If particular week day means like (first monday,second friday....)
          else {
            this.meetingService.monthlyMeetingStartDate(jsonOb).subscribe((data: any) => {
              if (data.body == null) {
                alert("no recursion found");

              }
              // if same date means(meeting start date and first recursive date)
              else if (this.datepipe.transform(data.body, "MMM dd, YYYY") == this.datepipe.transform(jsonOb.startDate, "MMM dd, YYYY")) {
                this.upDateValues(meetinObj.meetingId, meetingDate, code);
              }
              else {
                //update meeting date here as data.body value
                meetingDate = this.datepipe.transform(data.body, "MMM dd, YYYY");
                this.upDateValues(meetinObj.meetingId, meetingDate, code);
              }

            })
          }


        }

        else if (this.insDescpComp.meetingFrequency.value == 'Y') {

          if (this.insDescpComp.monthDay) {
            onDate[0] = this.insDescpComp.repeatMonthYearValue
            onDate[1] = this.insDescpComp.repeatDayInYearValue
          }
          if (this.insDescpComp.monthweekDay) {
            onDate[0] = this.insDescpComp.repeatYearlyInMonthValue
            onDate[1] = this.insDescpComp.repeatYearlyWeekValue
            onDate[2] = this.insDescpComp.repeatYearlyWeekDayValue
          }
          if (onDate.length == 2) {
            //january means 0 feb means 1....
            if (onDate[0] == (new Date(this.insDescpComp.meetingDate.value)).getMonth() && onDate[1] == (new Date(this.insDescpComp.meetingDate.value)).getDate()) {
              //nothing
              this.upDateValues(meetinObj.meetingId, meetingDate, code);

            }
            else {
              var json = {
                startDate: this.insDescpComp.meetingDate.value,
                endDate: new Date(String(this.insDescpComp.recurTillDateStr.value)),
                visitorTimeZone: this.globals.vTimeZone,
                frequentVal: this.insDescpComp.repeatValue,
                onDate: onDate
              }
              this.meetingService.yearlyMeetingStartDate(json).subscribe((data: any) => {
                ///here need to update meeting date
                if (data.body == null) {
                  alert("no recurring found");
                }
                else {
                  meetingDate = this.datepipe.transform(data.body, "MMM dd, YYYY");
                  this.upDateValues(meetinObj.meetingId, meetingDate, code);
                }
              })

            }
          }

          if (onDate.length == 3) {
            json = {
              startDate: this.insDescpComp.meetingDate.value,
              endDate: new Date(String(this.insDescpComp.recurTillDateStr.value)),
              visitorTimeZone: this.globals.vTimeZone,
              frequentVal: this.insDescpComp.repeatValue,
              onDate: onDate
            }
            this.meetingService.yearlyMeetingStartDate(json).subscribe((data: any) => {
              if (data.body == null) {
                alert("no recurring found");

              }
              else if (this.datepipe.transform(data.body, "MMM dd, YYYY") == this.datepipe.transform(json.startDate, "MMM dd, YYYY")) {
                this.upDateValues(meetinObj.meetingId, meetingDate, code);

              }
              else {
                meetingDate = this.datepipe.transform(data.body, "MMM dd, YYYY");
                this.upDateValues(meetinObj.meetingId, meetingDate, code);
              }
              //first check if meeting date and this response dates are same or not
              ///here need to update meeting date
            })


          }

        }

        else if (this.insDescpComp.meetingFrequency.value == 'D') {
          this.upDateValues(meetinObj.meetingId, meetingDate, code);
        }
      } else {
        this.insDescpComp.recurTillDateStr.markAsTouched();//([Validators.required]);
      }
    } else {
      this.scheduleMeeting(meetinObj.meetingId, code);
    }
    event.preventDefault();
    event.stopPropagation();
  }

  upDateValues(meetingId: any, meetingDate: any, code: any) {
    this.insDescpComp.updateTillDates(meetingId, meetingDate).then(() => {
      this.createRecurParentMeeting(meetingId).then(() => {
        this.scheduleMeeting(meetingId, code);
      })
    });
  }



  createRecurParentMeeting(meetingId: any) {
    return new Promise((resolve, reject) => {
      const reqJson = {
        "meetingId": meetingId,
        "userId": this.globals.userId,
        "visitorTimeZone": this.globals.vTimeZone
      }
      this.spinner.show();
      this.meetingService.createRecurParentMeeting(reqJson).subscribe(res => {
        resolve(res);
      }).add(() => {
        this.spinner.hide();
      });
    });
  }

  isOpenMeetingInfo() {
    const OpenMeetingInfo = <HTMLElement>document.getElementById('OpenMeetingInfo');

    const displays = window.getComputedStyle(OpenMeetingInfo, null).display

    if (displays == 'none') {
      $("#OpenMeetingInfo").toggle()
    }
    const meetingTitleChanger = <HTMLElement>document.getElementById('meeting-title-changer');
    meetingTitleChanger.contentEditable = 'true'
    // meetingTitleChanger.click()
    meetingTitleChanger.focus()
    meetingTitleChanger.style.borderBottom = '2px dashed black';
    const editIcon = <HTMLElement>document.getElementById('edit-icon');
    editIcon.hidden = true;
    const dateDetails = <HTMLElement>document.getElementById('date-details');
    dateDetails.hidden = true
    if (this.meetingResponse.commonMomStatusCode != undefined && this.meetingResponse.commonMomStatusCode == environment_const.momApproveStatus) {
      this.sideNav.disablePageAfterApproval();
    }
  }

  showEditIconAfterBlur() {
    const meetingTitleChanger = <HTMLElement>document.getElementById('meeting-title-changer');
    meetingTitleChanger.contentEditable = 'false'
    const editIcon = <HTMLElement>document.getElementById('edit-icon');
    editIcon.hidden = false;
    meetingTitleChanger.style.borderBottom = '0px';
  }

  isOpenShortcutView() {
    this.sideNav.meetingStarted.next(this.meetingStarted);
    this.matDialogShortCut = this.dialog.open(ShortcutDialogComponent, {
      panelClass: ['animate__animated', 'animate__slideInRight','shortcut-view-panel'],
      disableClose: true,
      position: {
        left: "75%"
      },
      maxWidth: "100%",
      maxHeight: "100vh",
      width: "40%",
      height: "100vh",
      hasBackdrop: false
    });
    const mediumDialogSubscription = this.isMedium.subscribe(size => {
      if (size.matches) {
        this.matDialogShortCut.updateSize('70vw', '100vh');
      }
    })
    const smallSubscription = this.isSmall.subscribe(size => {
      if (size.matches) {
        this.matDialogShortCut.updateSize('100vw', '100vh');
      }
    })
    const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
      if (size.matches) {
        this.matDialogShortCut.updateSize('100vw', '100vh');
      }
      // else {
      //   this.matDialogRef.updateSize('50%', '100vh');
      // }
    });
    this.matDialogShortCut.afterClosed().subscribe((data) => {
      mediumDialogSubscription.unsubscribe()
      smallSubscription.unsubscribe()
      smallDialogSubscription.unsubscribe()
    });
    const openShortCut = <HTMLElement>document.getElementById('open-short-cut');
    openShortCut.setAttribute('disabled', 'true')
  }

  triggerLinkMeetingFromDescription(bool: boolean) {
    if (bool == true) {
      this.openPreviousMeetingHistoryDailog()
    }
  }

  copyMeeting(meeting: any) {



    this.matDialogRef = this.dialog.open(CopymeetingComponent, {
      data: { meeting },
      panelClass: ['animate__animated', 'animate__slideInLeft'],
      disableClose: true,
      position: {
        left: "0%"
      },
      maxWidth: "100vw",
      maxHeight: "100vh",
      width: "50%",
      height: "100vh"
    });
    const mediumDialogSubscription = this.isMedium.subscribe(size => {
      if (size.matches) {
        this.matDialogRef.updateSize('70vw', '100vh');
      }
    })
    const smallSubscription = this.isSmall.subscribe(size => {
      if (size.matches) {
        this.matDialogRef.updateSize('100vw', '100vh');
      }
    })
    const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
      if (size.matches) {
        this.matDialogRef.updateSize('100vw', '100vh');
      }
      // else {
      //   this.matDialogRef.updateSize('50%', '100vh');
      // }
    });

    this.matDialogRef.afterClosed().subscribe((data) => {
      if (data == true) {
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        this.router.onSameUrlNavigation = 'reload';
        this.router.navigate(['dashboard']);
        this.sideNav.openInstantMeeting(false);
        mediumDialogSubscription.unsubscribe()
        smallSubscription.unsubscribe()
        smallDialogSubscription.unsubscribe()
      } else {
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        this.router.onSameUrlNavigation = 'reload';
        this.sideNav.openInstantMeeting(false);
        mediumDialogSubscription.unsubscribe()
        smallSubscription.unsubscribe()
        smallDialogSubscription.unsubscribe()
      }
    });

  }

  toggleToLinkMeeting() {
    this.setPaneView(true, false)
    this.spinner.show()
    this.openPreviousMeetingHistoryDailog()
    setTimeout(() => {
      this.spinner.hide()
    }, 200)
  }

  viewPreviousAgenda(agListVal: any) {
    this.prevAgendaInfoList = [];
    this.curAgendaInfo = {};
    if (agListVal != null && agListVal != undefined && agListVal.agList != null && agListVal.agList != undefined) {
      // this.prevAgendaInfoList=agListVal.agList;
      this.curAgendaInfo = agListVal.agList;
      //var pageReq={"idisplayLength":10,"idisplayStart":0};
      this.meetingService.fetchPrevAgendaHis(agListVal.agList, environment_const.idisplayStart, environment_const.idisplayLength).then((resp: any) => {
        this.prevAgendaInfoList = resp;
        /// alert added for empty response
        if (resp.totalCount == 0) {
          this.notifier.show({
            type: 'error',
            message: environment_msg.msg_error_no_previous_agenda_linked
          });
        } else {
          this.openPreviousMeetingHistoryDailog();
        }
      });
    }
    this.setPaneView(false, true)
    this.spinner.hide()
  }

  setPaneView(previousMeetingBool: any, previousAgendaBool: any) {
    this.previousMeetingDialogBool = previousMeetingBool;
    this.previousAgendaDialogBool = previousAgendaBool;
  }

  openPreviousMeetingHistoryDailog(agListVal: any = null) {
    //this.viewSwap = true;
    //this.swapView();
    document.querySelectorAll('.as-split-gutter').forEach((x, index) => {
      x.classList.remove('pointer-events-none')
    })
    this.spinner.show();
    this.pinDialogTriggered = true
    this.oneTimeScrollVideo = true
    this.rightPane = 50;
    const matTabHeader = document.getElementsByClassName('mat-tab-header');
    const matTabBodyWrapper = document.getElementsByClassName('mat-tab-body-wrapper');
    const OpenMeetingInfo = <HTMLElement>document.getElementById('OpenMeetingInfo');
    // let linkTabContainer = document.getElementById('link-tab-container');
    // let linkedTabContainer = document.getElementById('linked-tab-container');



    const displays = window.getComputedStyle(OpenMeetingInfo, null).display

    if (displays == 'inline') {
      $("#OpenMeetingInfo").toggle()
    }
    const meetingTitleChanger = <HTMLElement>document.getElementById('meeting-title-changer');
    const editIcon = <HTMLElement>document.getElementById('edit-icon');
    editIcon.hidden = false;
    const dateDetails = <HTMLElement>document.getElementById('date-details');
    dateDetails.hidden = false
    meetingTitleChanger.contentEditable = 'false'
    meetingTitleChanger.style.borderBottom = '0px';
    // let participantAccordionContainer = <HTMLElement>document.getElementById('participant-accordion-container');

    // if(this.participantExpansion == true){
    //   participantAccordionContainer.click()
    // }
    // this.participantExpansion = false
    setTimeout(() => {
      this.spinner.hide()
      // this.spinner.show();


      matTabHeader[0]?.setAttribute('style', 'margin-top : 10px!important')
      matTabBodyWrapper[0]?.setAttribute('style', 'height : calc(100vh - 150px)!important; overflow : hidden!important')
      // linkTabContainer?.setAttribute('style','height: calc(100vh - 194px);width: 100%;overflow-y: auto;')
      // linkedTabContainer?.setAttribute('style','height: calc(100vh - 194px);width: 100%;overflow-y: auto;')
      // this.spinner.hide();
    }, 700)
    this.sideNav.dialogCheckedChecker(false)
    // this.sideNav.dialogCheckedEmitter()
  }

  useTemplate(meetingId: any, meetingType: any) {

    this.meetingService.getCategoryDetails().subscribe(response => {

      this.router.routeReuseStrategy.shouldReuseRoute = () => false;
      this.router.onSameUrlNavigation = 'reload';
      this.router.navigate(['templateView'], { queryParams: { 'response': response, 'meetingType': meetingType, 'meetingId': meetingId, 'calledFrom': '' }, skipLocationChange: true, replaceUrl: false })
    });
    // this.meetingService.getCategoryDetails().subscribe(response => {
    //   
    //    let useTemplateDialog = this.dialog.open(CreateMeetingComponent,{
    //      data:{response,meetingId}
    //    });
    //    const mediumDialogSubscription = this.isMedium.subscribe(size => {
    //     if(size.matches){
    //       useTemplateDialog.updateSize('70vw','100vh');
    //     }
    //   })
    //   const smallSubscription = this.isSmall.subscribe(size => {
    //     if(size.matches){
    //       useTemplateDialog.updateSize('100vw', '100vh');
    //     }
    //   })
    //   const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
    //     if (size.matches) {
    //       useTemplateDialog.updateSize('100vw', '100vh');
    //     } 
    //     // else {
    //     //   this.matDialogRef.updateSize('50%', '100vh');
    //     // }
    //   });
    //   useTemplateDialog.afterClosed().subscribe((data)=>{
    //     mediumDialogSubscription.unsubscribe()
    //     smallDialogSubscription.unsubscribe()
    //     smallSubscription.unsubscribe()
    //   });
    // });
  }

  viewMomPdfDialog(meetingResp: any) {
    const viewMinutes = this.dialog.open(ViewMomDialogComponent, {
      data: { meetingInfo: meetingResp },
      panelClass: ['parent-dialog-container'],
      maxWidth: "100%",
      maxHeight: "100vh",
      minWidth: "80%",
      minHeight: "80vh",
    })
    const mediumDialogSubscription = this.isMedium.subscribe(size => {
      if (size.matches) {
        viewMinutes.updateSize('70vw', '100vh');
      }
    })
    const smallSubscription = this.isSmall.subscribe(size => {
      if (size.matches) {
        viewMinutes.updateSize('100vw', '100vh');
      }
    })
    const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
      if (size.matches) {
        viewMinutes.updateSize('100vw', '100vh');
      }
      // else {
      //   this.matDialogRef.updateSize('50%', '100vh');
      // }
    });
    viewMinutes.afterClosed().subscribe((data) => {
      mediumDialogSubscription.unsubscribe()
      smallDialogSubscription.unsubscribe()
      smallSubscription.unsubscribe()
    });
  }

  saveTemplate(meetingResponse: any) {

    const saveTemplateDialog = this.dialog.open(SaveTemplateDialogComponent, {
      data: { meetingResponse },
      // position : {
      //   left : "0%"
      // },
      // panelClass: ['animate__animated','animate__slideInLeft'],
      disableClose: false,
      // height : "60vh",
      maxWidth: "100%",
      // maxHeight: "100vh",
      width: "50%"
    });
    // const mediumDialogSubscription = this.isMedium.subscribe(size => {
    //   if(size.matches){
    //     saveTemplateDialog.updateSize('50%','');
    //   }
    // })
    const smallSubscription = this.isSmall.subscribe(size => {
      if (size.matches) {
        saveTemplateDialog.updateSize('100%', '');
      }
    })
    const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
      if (size.matches) {
        saveTemplateDialog.updateSize('100%', '');
      }
      else {
        this.matDialogRef.updateSize('50%', 'auto');
      }
    });
    saveTemplateDialog.afterClosed().subscribe((data) => {
      // mediumDialogSubscription.unsubscribe()
      smallDialogSubscription.unsubscribe()
      smallSubscription.unsubscribe()
    });
  }

  removePane(number: any) {
    if (this.showLeftVideo) {
      document.querySelectorAll('.as-split-gutter').forEach((x, index) => {
        x.classList.add('pointer-events-none')
      })
    }
    this.pinDialogTriggered = false
    this.rightPane = number;
    const matTabBodyWrapper = document?.getElementsByClassName('mat-tab-body-wrapper');
    const matTabHeader = document?.getElementsByClassName('mat-tab-header');
    matTabHeader[0]?.removeAttribute('style')
    matTabBodyWrapper[0]?.removeAttribute('style')
    this.setPaneView(false, false)
  }

  updateMeetingTitle(meetingId: any) {
    const roleFlag = this.permissionService.checkRoleRightsWithAlert(this.utilityService.featureList.MEETINGS, this.utilityService.permissionType.MODIFY);

    if (!roleFlag) {
      return;
    }
    if (this.meetingTitleEdit == undefined) {
      const title = <HTMLElement>document.getElementById("meeting-title-changer")
      this.meetingTitleEdit = title.innerText;
    }
    if (this.meetingTitleEdit == '' || this.meetingTitleEdit.trim().length == 0) {
      // let title = <HTMLElement>document.getElementById("meeting-title-changer")
      this.meetingTitleEdit = 'Untitled Meeting';
      const title = <HTMLElement>document.getElementById("meeting-title-changer")
      title.innerHTML = 'Untitled Meeting';
    }

    //  this.meetingTitleEdit=<HTMLElement>document.getElementById("meeting-title-changer");
    if (this.duration == undefined && this.meetingDateStr == undefined && this.meetingStartTime == undefined) {

      this.duration = this.meetingResponse.duration;
      this.meetingDateStr = this.meetingResponse.meetingDateShortFormat

      if (this.meetingResponse.meetingUTCDate != null) {
        const curSysDate = new Date(this.meetingResponse.meetingUTCDate);
        const tempDate = new Date(curSysDate.getTime());
        const _utcDate = new Date(tempDate.getUTCFullYear(), tempDate.getUTCMonth(), tempDate.getUTCDate(), tempDate.getUTCHours(), tempDate.getUTCMinutes(), tempDate.getUTCSeconds());
        const fullDate = new Date(_utcDate.getTime() + (3600000 * (this.globals.vTimeZoneIntOffset)));//convert utc to corresponding timezone
        const hour = this.addZero(fullDate.getHours());
        const minutes = this.addZero(fullDate.getMinutes());

        this.meetingStartTime = hour + ":" + minutes;

      }
      //this.meetingStartTime = this.meetingResponse.meetingStartTime
    }

    const meetingTitleJson = {
      "meetingTitle": this.meetingTitleEdit,
      "userId": this.globals.userId,
      "decryptKey": localStorage.getItem("decryptKey"),
      "encryptTitleKey": this.meetingTitleEdit
    }
    this.collabMeetingDetails = <MeetingCollabDetails>{};
    this.collabMeetingDetails.elementId = this.meetingResponse.meetingId;
    this.collabMeetingDetails.fieldName = "meetingTitle";
    this.collabMeetingDetails.fieldValue = this.meetingTitleEdit
    this.collabMeetingDetails.collabType = "MEETING";

    this.meetingService.updateMeetingTitle(meetingId, meetingTitleJson).subscribe(responsedata => {
      this.callWebsocketService(this.collabMeetingDetails)
    });
    this.meetingResponse.meetingTitle = this.meetingTitleEdit
    this.meetingTitleChanges = this.meetingTitleEdit

  }
  addZero(i: any) {
    if (i < 10) {
      i = "0" + i;
    }
    return i;
  }
  getMeetingTitle(event: any) {
    this.meetingTitleEdit = event.target.innerText;
    const title = <HTMLElement>document.getElementById("meeting-title-changer")
    if (this.meetingTitle == '' || this.meetingTitle == null || this.meetingTitle == undefined) {
      title.style.borderLeft = "1px dashed white"
    }
    else {
      title.style.borderBottom = "2px dashed black"
    }

  }
  callWebsocketService(responsedata: any) {
    responsedata.meetingId = this.meetingResponse.meetingId;
    this.webTranService.pushMesssageToProducer(this.meetingResponse.meetingId, responsedata).subscribe((data) => {

    });
  }
  getRoleCodeRights(meetingResponse: any) {

    if (meetingResponse.attendeeList != undefined && meetingResponse.agendaList != undefined) {
      let roleFlag = true;
      let rolecode: any;
      if (roleFlag) {
        meetingResponse.attendeeList.forEach((elem: any, agIndex: any) => {
          if (localStorage.userId == elem.fkSecUserAttendee) {
            rolecode = elem.attendeeRole
            roleFlag = false;

          }
        });
      }
      if (roleFlag) {
        meetingResponse.agendaList.forEach((elem: any, agIndex: any) => {
          elem.minutesList.forEach((minEle: any, agIndex: any) => {
            if (minEle.entityType == "AI") {
              if (minEle.assignedTo == localStorage.userId) {
                rolecode = "TU"
                roleFlag = false;
              } else {
                const actionItemOwner = JSON.parse(minEle.assignedTo);
                actionItemOwner.forEach((taskEle: any, agIndex: any) => {
                  if (localStorage.userId == taskEle.fkSecUserOwner) {
                    rolecode = "TU"
                    roleFlag = false;

                  }
                });
              }
            }
          });
        });

      }
      if (roleFlag) {
        const reportingUserArray = this.globals.repotingUsers.split(',');
        meetingResponse.attendeeList.forEach((elem: any, agIndex: any) => {

          for (var i = 0; i < reportingUserArray.length; i++) {
            if (reportingUserArray[i] == elem.fkSecUserAttendee) {
              rolecode = "SO";

              roleFlag = false;
            }
          }
        });
      }
      const reqJson = {
        "roleCode": rolecode
      }
      this.userService.getRoleRights(reqJson).subscribe((roleRightsMap: any) => {

        this.globals.roleRightsMap = roleRightsMap
      });

    }
  }
  checkuserAvailability(meetingData: any) {
    const meetingResp = meetingData;
    let attendeeDetails = "";
    let conflictTime = "";
    const platformIdentifer: any[] = [];

    meetingResp.attendeeList.forEach((attendee: any) => {

      attendeeDetails += attendee.fkSecUserAttendee + ",";

    });



    const reqCheckUserAvailability = {


      "attendeeDetails": attendeeDetails,
      "duration": meetingResp.duration,
      "meetingDate": meetingResp.meetingDateShortFormat,
      "meetingId": meetingResp.meetingId,
      "meetingStartTime": meetingResp.meetingStartTime,
      "timeZone": this.globals.vTimeZone,
      "userId": this.globals.userId,
      "orgCode": localStorage.orgCode


    }

    meetingResp.attendeeList?.forEach((attendee: any) => {
      if (attendee.fkSecUserAttendee == null) {
        attendee.availableStatus = "Available"
      }
    })
    if (meetingData.meetingStartFlag != "Y") {
      this.attendeeService.checkUserAvailability(reqCheckUserAvailability).subscribe((dataObj) => {
        Object.values(dataObj.conflictTimingsMap).map((x: any, i: any) => {

          if (x.length == 0) {
            meetingResp.attendeeList?.forEach((attendee: any) => {
              if (attendee.fkSecUserAttendee == Object.keys(dataObj.conflictTimingsMap)[i]) {
                attendee.availableStatus = "Available"
              }
            });
          } else {
            meetingResp.attendeeList?.forEach((attendee: any) => {
              if (attendee.fkSecUserAttendee == Object.keys(dataObj.conflictTimingsMap)[i]) {
                attendee.availableStatus = "Tentative"
                let conflictMap: any = [];
                const attendeeInformation: any = []
                conflictMap = Object.values(dataObj.conflictTimingsMap)[i];
                conflictMap.forEach((time: any, index: any) => {

                  attendeeInformation.push(time.meetingType)
                  if (conflictMap.length > 1) {
                    platformIdentifer.push(time.meetingType)
                    conflictTime += time.conflictStarttime + " - " + time.conflictEndtime + "," + " ";
                  } else {
                    conflictTime += time.conflictStarttime + " - " + time.conflictEndtime;
                  }
                })
                attendee.conflictTime = conflictTime;
                attendee.attendeeMeetingInformation = attendeeInformation
                conflictTime = '';
              }
            });

          }
        })

        if (meetingResp.meetingStatusCode == 'COM') {
          this.meetingEnded = true;
          this.meetingStarted = true;
        }

        if (this.meetingResponse.meetingStatusCode == 'BSCH' || this.meetingResponse.meetingStatusCode == 'SCH' && this.sideNav.openInstantMeetingTransmitter() == false) {

          this.meetingEnded = false;
          this.meetingStarted = false;

        }
      });
    }

    return meetingResp;
  }

  toggleZoom() {

    this.showSideToggle = !this.showSideToggle;
    this.pinDialogTriggered = true;
    // this.swapView();
  }

  openDraggableDialog() {

    (document.getElementById('speech-to-text-section') as HTMLElement).style.display = 'none'
    document.getElementById('speech-to-text-section')?.style.display!
    this.dragDialogRef = this.dialog.open(DragDialogComponent, {
      hasBackdrop: false,
      panelClass: 'drag-dialog-parent',
      data: {
        content: this.audioContent,
        startflag: this.meetingResponse.meetingStartFlag,
        endflag: this.meetingResponse.meetingEndFlag
      }
    })
    this.dragDialogRef.afterClosed().subscribe(() => {
      (document.getElementById('speech-to-text-section') as HTMLElement).style.display = 'block';
    })
    this.dragDialogRef.componentInstance.emitContent.subscribe(res => {
      this.speechContent = res
    })
  }

  ngDestroy() {
    localStorage.setItem("decryptKey", "")
    this.sideNav.pinShortCutDialog(false)
  }

  sendMessage(meetingResp: any) {
    const reviewSelect = this.dialog.open(SendMessageDialogComponent, {
      data: {
        title: "Notification",
        meetingResp: meetingResp
      },
      panelClass: ['animate__animated', 'animate__slideInLeft'],
      disableClose: true,
      position: {
        left: "0%"
      },
      maxWidth: "100%",
      maxHeight: "100vh",
      width: "50%",
      height: "100vh"
    });

    const mediumDialogSubscription = this.isMedium.subscribe(size => {
      if (size.matches) {
        reviewSelect.updateSize('70vw', '100vh');
      }
    })

    const smallSubscription = this.isSmall.subscribe(size => {
      if (size.matches) {
        reviewSelect.updateSize('100vw', '100vh');
      }
    })
    const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
      if (size.matches) {
        reviewSelect.updateSize('100vw', '100vh');
      }
    });
    reviewSelect.afterClosed().subscribe((data: any) => {
      mediumDialogSubscription.unsubscribe()
      smallSubscription.unsubscribe()
      smallDialogSubscription.unsubscribe()
      this.fetchMoMDetailListByMeeting();
    });
  }
  taskCount(event: any) {
    // if(event.ismailsent == -1){
    //   this.showSendTask = true;
    // }
  }

  sendTask(meetingResp: any) {
    var json = {
      meetingId: meetingResp.meetingId
    }
    this.meetingService.sendNotificationTask(json).subscribe((data: any) => {
      if (data.body.message == "success")
        this.spinner.hide();
      this.sideNav.alertNotifySuccess("Task Sent Successfully");
      this.showSendTask = false;
      this.isMailSentCount = 0;
    }, error => {
      this.spinner.hide();
      this.sideNav.alertNotifySuccess("Error : " + error);
    })
  }
  meetinghistory(meetingResponse: any) {
    var meetingid = meetingResponse.meetingId;
    var meetingTitle = meetingResponse.meetingTitle
    console.debug("check console ", meetingResponse.meetingTitle)
    var type = true;
    let linkDialog = this.dialog.open(HistoryComponent, {
      data: { meetingid, type, meetingTitle },
      panelClass: ['animate__animated', 'animate__slideInLeft'],
      disableClose: true,
      position: {
        left: "0%"
        //top  :"10%"
      },
      maxWidth: "75%",
      maxHeight: "100vh",
      width: "75%",
      height: "100vh"
    })

    const mediumDialogSubscription = this.isMedium.subscribe(size => {
      if (size.matches) {
        linkDialog.updateSize('70vw', '100vh');
      }
    })
    const smallSubscription = this.isSmall.subscribe(size => {
      if (size.matches) {
        linkDialog.updateSize('100vw', '100vh');
      }
    })
    const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
      if (size.matches) {
        linkDialog.updateSize('100vw', '100vh');
      }
    });
    linkDialog.afterClosed().subscribe((response: any) => {
      mediumDialogSubscription.unsubscribe()
      smallSubscription.unsubscribe()
      smallDialogSubscription.unsubscribe()

    })

  }
  handleMeetingMediumChanged(newMeetingMedium: any) {
    this.meetingResponse.zoomMeetingId = newMeetingMedium.zoomMeetingId;
    this.mediumCodeList = this.meetingMediumResponse;
    var zoomFlag = false;
    this.mediumCodeList.forEach((obj: any, index: any) => {
      if (obj.codeId == this.meetingResponse.meetingMedium && obj.description == "Zoom") {
        zoomFlag = true;
      }
    });
    if (zoomFlag) {
      this.showStart = false;
    } else {
      this.showStart = true;
    }
  }

  startRecording(meetingId: any) {
    this.selectedTrack = false;
    this.recording = true;
    const mediaConstraints = { video: false, audio: true };
    navigator.mediaDevices.getUserMedia(mediaConstraints)
      .then(this.successCallback.bind(this), this.errorCallback.bind(this));
  }
  successCallback(stream: MediaStream) {
    const options = {
      mimeType: "audio/wav",
      numberOfAudioChannels: 1,
      sampleRate: 44100
    };
    this.notifierService.show({
      type: 'success',
      message: environment_msg.msg_notify_audio_recording
    });
    this.selectedTrack = false;
    this.recording = true;
    navigator.mediaDevices.getUserMedia({ audio: true }).then(function (mic) {
      stream.addTrack(mic.getTracks()[0]);
    });
    const StereoAudioRecorder = RecordRTC.StereoAudioRecorder;
    this.record = new StereoAudioRecorder(stream, { mimeType: "audio/wav", numberOfAudioChannels: 1, sampleRate: 44100 });

    this.record.record();

    this.intervalId = setInterval(() => {
      this.record.stop(this.processRecording.bind(this));
      this.record.record();
      this.recording = true;
    }, 20000);

  }
  async processRecording(blob: Blob) {
    this.websocketService.sendBinaryDataToWebSocket(blob, this.meetingResponse.meetingId);
  }

  errorCallback(error: any) {

    this.notifier.show({
      type: 'success',
      message: environment_msg.msg_error_mic
    })
    this.selectedTrack = true;
    this.recording = false;
    this.spinner.hide();
  }
  stopRecording(meetingRes: any) {
    clearInterval(this.intervalId);
    this.selectedTrack = true;
    this.recording = false;
    this.spinner.show();
    if (this.record != undefined || this.record != null) {
      this.record.stop(this.processRecording.bind(this));
      this.record = null;
      setTimeout(() => {
        var req = {
          meetingId: meetingRes.meetingId,
          createdBy: meetingRes.facilitatorId
        }
        this.attachment.mergeAudio(req).subscribe((data: any) => {
          this.spinner.hide();
          if (data.attachmentMode == 'success') {
          }
        }, error => {
          this.spinner.hide();
          alert(error);
        })

      }, 3000);
    }
  }

  fetchAudio(meetingId: any) {
    this.audioSpinner = true;
    this.closeFetch('');
    this.attachment.downloadAudio(meetingId + "").subscribe((data: any) => {
      if (data.body.length != 0) {
        this.audioNotFound = false;
        this.audioSource = [];
        var fetchAudio = new Promise<void>((resolve, reject) => {
          data.body.forEach((file: any, index: any, array: any) => {
            var req = JSON.parse(JSON.stringify(file));
            this.attachment.getAudioAttachmentById(req.attachmentId).subscribe((res: any) => {
              if (res.body != undefined && res.body != null) {
                let blobresp = res.body;
                let blob = new Blob([blobresp], { type: blobresp.type });
                var value = {
                  "audioSource": this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(blob)),
                  "attachment": req
                }
                this.audioSource.push(value);
              }
              if (index === array.length - 1) resolve();
            })
          })
        });

        fetchAudio.then(() => {
          this.audioSpinner = false;
        });
      }
      else {
        this.audioSpinner = false;
        this.audioNotFound = true;
      }
    });
  }
  showAudioControls(index: number, audioTag: HTMLAudioElement): void {
    if (this.currentAudioTag && this.currentAudioTag !== audioTag) {
      this.currentAudioTag.pause();
      this.currentAudioTag.currentTime = 0;
    }
    this.activeAudioIndex = index;
    this.clickedMusicNoteIndex = null;
    this.currentAudioTag = audioTag;
    audioTag.play();
  }

  hideAudioControls(): void {
    this.activeAudioIndex = null;
  }

  onClickNotes(index: number, actionFor: string): void {
    if (actionFor == 'fetch') {
      this.clickedMusicNoteIndex = index;
      this.activeAudioIndex = index;
    }
    else if (actionFor == 'play') {
      this.clickedMusicNoteIndex = index;
      this.activeAudioIndex = index;
    }
  }


  closeFetch(actionFor: string) {
    if (actionFor == 'audioList') {
      if (this.fetchSubscription) {
        this.fetchSubscription.unsubscribe();
      }
      this.audioSource = [];
      this.showControls = false;
      this.activeAudioIndex = null;
      this.clickedMusicNoteIndex = null;
    }
    if (actionFor == 'accordion') {
      this.fetchAudioIcon = false;
      this.clickedMusicNoteIndex = null;
      this.audioContent = null;
    }

  }

  listToggle() {
    this.fetchAudioIcon = !this.fetchAudioIcon;
  }

  audioListToggle() {
    this.fetchAudioIcon = true;
  }

  fetchContent(attachment: any) {
    this.attachment.fetchContent(attachment.attachmentId).subscribe((data: any) => {
      if (data.body.attachmentContentType != null) {
        this.audioContent = data.body.attachmentContentType;
      }
    })
  }
  onUpdateTimerTracker(updatedArray: number[]) {
    this.timerTrackerArray = updatedArray;
  }
  textConvertion(attachment: any) {
    this.attachment.textConvertion(attachment).subscribe((data: any) => {
      this.notifier.show({
        type: 'success',
        message: environment_msg.msg_success_textConvertion
      })
    })
  }


  speechToTextrecord: any;
  speechToTextScreenStream: MediaStream | null = null;;
  speechToTextinterval: any;

  startSpeechToTextRecording(meetingId: any) {
    this.isToggleChecked = false;
    const mediaConstraints = { video: false, audio: true };
    navigator.mediaDevices.getUserMedia(mediaConstraints)
      .then(this.successCallbackSpeechToText.bind(this), this.errorCallbackSpeechToText.bind(this));
  }
  successCallbackSpeechToText(stream: MediaStream) {
    this.notifierService.show({
      type: 'success',
      message: environment_msg.msg_notify_audio_recording
    });
    this.isToggleChecked = true;
    this.speechToTextScreenStream = stream;


    const StereoAudioRecorder = RecordRTC.StereoAudioRecorder;
    // this.speechToTextrecord = new StereoAudioRecorder(stream,{mimeType:"audio/wav",numberOfAudioChannels:1,sampleRate:16000,desiredSampRate: 16000,recorderType: StereoAudioRecorder});
    this.speechToTextrecord = new StereoAudioRecorder(stream, { mimeType: "audio/wav", numberOfAudioChannels: 1, sampleRate: 44100 });
    this.speechToTextrecord.record();

    this.speechToTextinterval = setInterval(() => {
      this.speechToTextrecord.stop(this.processSpeechToTextRecording.bind(this));
      this.speechToTextrecord.record();
    }, 5000);

  }
  async processSpeechToTextRecording(blob: Blob) {
    this.websocketService.sendSpeechAudioToWebSocket(blob, this.meetingResponse.meetingId);
  }

  errorCallbackSpeechToText(error: any) {
    this.notifier.show({
      type: 'success',
      message: environment_msg.msg_error_mic
    })
    this.isToggleChecked = false;
    this.spinner.hide();
  }
  previewShareAgenda(meetingResp: any) {
    const roleFlag = this.permissionService.checkRoleRightsWithAlert(this.utilityService.featureList.MINUTES, this.utilityService.permissionType.MODIFY);
    if (!roleFlag) {
      return;
    }
    this.momService.fetchAgendaMinutesCount(this.meetingResponse.meetingId).subscribe((resp: any) => {
      if (resp != null && resp != undefined && resp.count != undefined && resp.count <= 0) {
        this.notifier.show({
          type: 'error',
          message: environment_msg.msg_error_enter_notes_to_preview
        });
        return false;
        //check empty mom list
      } else {
        this.callPreviewAgednaDialog(meetingResp);
      }
      return true;
    })
    return true;
  }
  callPreviewAgednaDialog(meetingResp: any) {
    const previewMinutes = this.dialog.open(PreviewShareAgendaComponent, {
      data: { meetingInfo: meetingResp },
      panelClass: ['parent-dialog-container'],
      maxWidth: "100%",
      maxHeight: "100vh",
      width: "80%",
      height: "100vh"
    })
    const mediumDialogSubscription = this.isMedium.subscribe(size => {
      if (size.matches) {
        previewMinutes.updateSize('70vw', '100vh');
      }
    })
    const smallSubscription = this.isSmall.subscribe(size => {
      if (size.matches) {
        previewMinutes.updateSize('100vw', '100vh');
      }
    })
    const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
      if (size.matches) {
        previewMinutes.updateSize('100vw', '100vh');
      }
      // else {
      //   this.matDialogRef.updateSize('50%', '100vh');
      // }
    });
    previewMinutes.afterClosed().subscribe((data) => {
      this.fetchMoMDetailListByMeeting();
      mediumDialogSubscription.unsubscribe()
      smallDialogSubscription.unsubscribe()
      smallSubscription.unsubscribe()
    });
  }

  checkshortcuts(){
    return window.innerWidth > 1510;
  }
  updateTranscriptionsText() {
      const lines = (this.transcriptions || []).map((t: any) => `${t.speaker}: ${t.text}`);
      this.audioContent = lines.join('\n');
   
      // If draggable dialog is open, push live updates and scroll within it
      if (this.dragDialogRef && this.dragDialogRef.componentInstance &&
          typeof (this.dragDialogRef.componentInstance as any).setContent === 'function') {
        (this.dragDialogRef.componentInstance as any).setContent(this.audioContent);
      }
  }
}
